import { ACCOUNT_TYPE } from './constants';
import { ContractLengthComponent } from '../container/B2B/B2BAdmin/Earnings/BTBEarning';
import moment from 'moment';

export const noticeMessages = {
  getTrialExpiryMessage: (trialDaysLeft) => {
    return `Trial will end in ${trialDaysLeft} days`;
  },

  getCharityExpiryMessage: (contractEndDate) => {
    const daysLeft = moment(new Date(contractEndDate)).diff(moment(new Date()), 'days');
    return `Charity will end in ${daysLeft} days`;
  }
};

export const seatPriceInfo = {
  getPriceMessage: (currentPrice) => {
    return `Current seat price is ${currentPrice} £${parseInt(currentPrice) > 10 ? ' which is not valid' : ''
      } modify per seat price for new price`;
  }
};

export const LoginPageContent = {
  business: 'Business',
  welcomeBackText: {
    welcome: 'Welcome',
    back: 'back!',
    pleaseLogin: 'Please login to your account'
  },
  forgotPassword: 'Forgot your password?',
  loginBtnText: 'Login',
  resendBtnText: 'Resend',
  inputFieldLabel: {
    email: 'Email',
    password: 'Password',
    emailPlaceHolder: 'Enter your email',
    passwordPlaceHolder: 'Enter your password',
    emailErrorMessage: {
      message1: 'Please enter valid email address.',
      message2: 'Please enter the registered email address.'
    },
    passwordErrorMessage: {
      message1: 'Please enter password.',
      message2: 'Password must be greater than 6 digit.'
    },
    errorMessage: 'Please enter valid account details.',
    somethingWrong: 'Something went wrong!',
    successResponseMessage:
      'Otp sent successfully to your registered email, if not found please check your junk or spam folder.'
  },
  otpModal: {
    header: { text1: 'Please Enter the', text2: 'OTP' },
    description: 'Please enter the OTP sent to your email',
    notReceivedOTP: "Didn't received OTP?"
  }
};

export const ForgotPasswordPageContent = {
  forgotPasswordText: { text1: 'Forgot', text2: 'Password' },
  description: 'Enter registered email address to get the OTP for reset password',
  submitBtnText: 'Submit',
  backToLoginBtnText: 'Back to login',
  inputField: {
    emailLabel: 'Email Address',
    emailPlaceHolder: 'Enter your email',
    emailErroMessage: {
      message1: 'Please enter valid email address.',
      message2: 'Please enter the registered email address.'
    }
  }
};

export const DonutChartCardData = {
  total: 'Total',
  modalLabel: 'Overall Responses',
  responses: 'Responses',
  noResponse: 'No Response'
};

export const emotionStatistics = {
  title: 'Emotions Statistics',
  description1: 'Understanding of your users',
  description2: 'emotions statistics on webapp.',
  depressed: 'Depressed',
  overJoyed: 'Overjoyed',
  sad: 'Sad',
  happy: 'Happy',
  neutral: 'Neutral'
};

export const DashboardContent = {
  metaTitle: 'Dashboard | Shoorah Admin',
  hitext: 'Hi',
  section1Array: {
    userDetailsSection: {
      title: 'User details',
      b2c: 'B2C',
      b2b: 'B2B',
      inActiveUsers: 'Inactive users',
      deleted: 'Deleted',
      totalUsers: 'Total users',
      subscriptionCount: 'Subscription count',
      oneMonth: 'One month',
      sixMonth: 'Six month',
      annual: 'Annual',
      lifetime: 'Lifetime'
    },
    accountDetailsSection: {
      title: 'Account details',
      trialAccount: 'Trial Account',
      deletedAccount: 'Deleted Account',
      paidAccount: 'Paid Account',
      basicPlan: 'Basic Plan',
      freeAccount: 'Free Account'
    }
  },
  section2Array: {
    active: 'Active',
    inActive: 'Inactive',
    activeMeditation: 'Active Meditation',
    sound: 'Sound',
    ritual: 'Ritual',
    affirmation: 'Affirmation',
    pod: 'Pod'
  },
  section3Array: {
    title: 'Focus details',
    activeMainFocus: 'Active Main Focus',
    inActiveMainFocus: 'Inactive Main Focus',
    activeAffirmationFocus: 'Active Affirmation Focus',
    inActiveAffirmationFocus: 'Inactive Affirmation Focus',
    totalFocus: 'Total Focus'
  },
  section4Array: {
    title: 'Cleanse',
    totalCleanse: 'Total cleanses',
    totalSolutionGenerated: 'Total solutions generated',
    totalAISupportRequested: 'Total Ai support requests'
  },
  section5Array: {
    title: 'Top key words (Categories)'
  },
  section6Array: {
    title: 'Goals',
    totalGoals: 'Total goals',
    totalSolutiongenerated: 'Total solutions generated',
    totalAISupportRequested: 'Total Ai support requests'
  },
  section7Array: {
    title: 'Top key words (Categories)'
  },
  surveyCardContent: {
    title: 'Survey Overview',
    description:
      'This stats boxes will show you the user activity status like login counts and app usage.',
    totalCreatedSurveys: 'Total Created Surveys',
    averageCompletionTime: {
      title: 'Average Completion Time',
      zero: '0',
      minutes: 'minutes',
      text1: '+0%',
      text2: 'Last 7 days'
    },
    completionRate: {
      title: 'Completion Rate',
      zero: '0%'
    },
    overallResponses: {
      title: 'Overall Responsess',
      responses: 'Responses',
      noResponse: 'No Response'
    }
  },
  assessmentCardContent: {
    title: 'Self Assessment',
    description:
      'This stats boxes will show you the user activity status like login counts and app usage.',
    completedAssessments: {
      title: 'Completed Assessments',
      completed: 'Completed',
      inComplete: 'Incomplete'
    },
    averageScore: {
      title: 'Average Scores',
      text1: '10-30',
      text2: '30-60',
      text3: '60-80',
      text4: '80-100',
      top5Assessments: 'Top 5 Assessments',
      assessmentNotFound: 'Assessment not found'
    }
  },
  section8Array: {
    sosDetails: {
      title: 'SOS details',
      totalUser: 'Total User',
      sosCount: 'SOS Count',
      callCount: 'Call Count',
      day1: '30 days',
      day2: '90 days',
      custom: 'Custom'
    },
    subscribeDetails: {
      title: 'Subscribe Details',
      subscribed: 'Subscribed',
      unSubscribed: 'Unsubscribed'
    },
    trialVsFreeUsers: {
      title: 'Trial v/s Free Users',
      trialUsers: 'Trial users',
      freePlanUsers: 'Free plan users'
    },
    activeSubscriptionPlans: {
      title: 'Active Subscription Plans',
      lifetime: 'Lifetime',
      oneMonth: '1 Month',
      sixMonth: '6 Month',
      oneYear: '1 year',
      total: 'Total'
    },
    shuruUsage: 'Shuru Usage',
    jobRole: {
      title: 'Job Roles %',
      description1: "Understanding of your users's percentage",
      description2: 'of job roles on app.',
      male: 'Male',
      notPrefer: 'Not Prefer',
      female: 'Female',
      nonBinary: 'Non Binary',
      interSex: 'Intersex',
      transGender: 'Transgender'
    },
    rippleStatistics: {
      title: 'Ripple Statistics',
      description1: "Understanding of your ripple users's stats",
      description2: 'on webapp.',
      totalMoods: 'Total Moods',
      totalHoursSpent: 'Total Hours Spent',
      totalActivatedUsers: 'Total Activated Users',
      totalNonActivatedUsers: 'Total Non Activated Users',
      moodsSelection: 'Moods Selections',
      hoursSpent: 'Hours Spent',
      activatedUsers: 'Activated Users',
      nonActivatedUsers: 'Non Activated Users',
      transgender: 'Transgender'
    },
    beforeSleepLogs: {
      title1: 'Before Sleep Logs',
      positive: 'Positive',
      negative: 'Negative',
      title2: 'During Sleep Logs'
    },
    breathWorkInsights: {
      title: 'Breathwork insights',
      description:
        'This will tell you total breathwork sessions attended and duration played by users.',
      totalSessions: 'Total Sessions',
      totalTimeSpent: 'Total Time spent',
      min: 'min'
    },
    overallWellBeing: {
      headerText:
        'System data sets for all users, starting the Shoorah Journey Vs Where the user is at now.',
      positive: 'positive',
      negative: 'negative',
      overallJournalWellBeing: 'Overall Journal wellbeing',
      overallShuruWellBeing: 'Overall Shuru wellbeing',
      overallPersonalEmotionsWellbeing: 'Overall Personal Emotions wellbeing',
      overallProfessionalEmotionsWellbeing: 'Overall Professional Emotions wellbeing',
      journal: 'Journal',
      shuru: 'Shuru',
      affirmation: 'affirmation',
      gratitude: 'gratitude',
      goals: 'goals',
      cleanse: 'cleanse',
      notes: 'notes',
      oneMonth: '1 month',
      secondMonth: '2 month',
      thirdMonth: '3 month',
      fourMonth: '4 month',
      fifthMonth: '5 month',
      sixthMonth: '6 month',
      seventhMonth: '7 month',
      pageA: 'Page A',
      pageB: 'Page B',
      pageC: 'Page C',
      pageD: 'Page D',
      pageE: 'Page E',
      pageF: 'Page F',
      pageG: 'Page G',
      positive1: 'Positive',
      negative1: 'Negative',
      reportName: 'Overall Well Being  Report'
    },
    userActivityDetails: {
      title: 'User Activity Details',
      description:
        'This stats boxes will show you the user activity status like login counts and app usage.',
      users: 'Users',
      timeSpent: 'Time Spent',
      hourSpent: 'Hours Spent',
      hr: 'hr',
      mins: 'mins',
      day: 'Day',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Yearly',
      custom: 'Custom'
    }
  }
};

export const RightSidebarData = {
  superAdmin: 'Super Admin',
  partner: 'Partner',
  subAdmin: 'Sub Admin',
  changePassword: 'Change Password',
  subscription: 'Subscription',
  trialPlan: 'You have Trial plan activated.',
  subscribedPlan: 'You are subscribed to shoorah business.',
  expiredPlan: 'You have Expired plan',
  noSubscriptionPlan: 'No Subscription found. Please buy shoorah business plans to use features.',
  aboutText: 'About',
  companyName: 'Shoorah ltd',
  aboutDescription: ' Building a mentally healthy workforce for a brighter future of work.',
  otherAdminMember: 'Other Admin Members',
  lastLoginText: 'Last Login',
  notActiveText: 'Not active',
  viewAllBtnText: 'View all',
  errorToastMessage: 'Something went wrong',
  moodRecordSuccessMessage: 'Your mood recorded successfully',
  onlyOneAdminMemberText: 'You are the only Admin member presently.',
  thirdBoxText: {
    howAreYouFeeling: 'How’re you feeling',
    thirdBoxDescription:
      'Take a moment to reflect. Regular check-ins can lower your stress & boost your mood!',
    thirdBoxDescription2: '*Your reflections are private'
  }
};

export const PartnerSidebarData = {
  shoorahPartner: 'Shoorah Partner',
  aboutText: 'About',
  aboutDescription: 'Building a mentally healthy workforce for a brighter future of work.',
  changePasswordText: 'Change Password'
};

export const LeftSidebarData = {
  errorToastMessage: 'Something went wrong',
  darkMode: 'Darkmode',
  logOut: 'Logout',
  adminParentMenu: {
    admin: 'Admin',
    dashboard: 'Dashboard',
    contentApproval: 'Content Approval',
    cms: 'CMS',
    config: 'Config',
    myCompany: 'My Company',
    report: 'Report'
  },
  peopleManagementParentMenu: {
    peopleManagement: 'People Management',
    users: 'Users',
    ourExperts: 'Shoorah Experts',
    adminShoorahStaff: 'Shoorah Admins',
    schoolManagement: 'School management',
    subAdmins: 'Shoorah Admins',
    childCompanies: 'Child Companies',
    teamChallanges: 'Team Challanges',
    myAccount: 'My Account',
    introduceCompanies: 'Introduce Companies',
    peoplePlan: 'People plan'
  },
  featuresAndToolsParentMenu: {
    featuresAndTools: 'Features & Tools',
    peapDashboard: 'PEAP Dashboard',
    b2bWellPoints: 'B2B WellPoints',
    specialistManager: 'Specialist Manager',
    pulseSurvey: 'Pulse Survey',
    instantSupport: 'Instant Support',
    instantSupportForB2BUsers: 'Instant Support (B2B Users)',
    instantSupportForB2CUsers: 'Instant Support (B2C Users)',
    shoorahTestDashboard: 'Shoorah Test Dashboard',
    shoorahTest: 'Shoorah Test',
    shoorahTestForB2CUsers: 'Shoorah Test (B2C Users)',
    shoorahTestForB2BUsers: 'Shoorah Test (B2B Users)',
    tutorials: "Tutorial's",
    pushNotifications: 'Push Notifications',
    earnings: 'Earnings',
    appIssues: 'App Issues',
    appFeedback: 'App Feedback',
    notifications: 'Notifications',
    legals: 'Legals',
    assets: 'Assets',
    pulseSurveys: 'Pulse Surveys',
    badges: 'Badges',
    integrations: 'Integrations',
    solutions: 'Solutions',
    peapWellbank: 'Peap Wellbank',
    instantSupportEAP: 'Instant Support',
    healthVideos: 'Health Videos',
    shoorahVids: 'Shoorah Vids',
    benefits: 'Shoorah Benefits'
  },
  eliteGamesParentMenu: {
    eliteGames: 'Elite Games',
    dashboard: 'Dashboard',
    quizZone: 'Quiz Zone',
    mainCategory: 'Main Category',
    subCategory: 'Sub Category',
    categoryOrder: 'Category Order',
    viewQuestions: 'View Questions',
    importQuestions: 'Import Questions',
    questionReports: 'Question Reports',
    dailyQuiz: 'Daily Quiz',
    multiMatch: 'Multi Match',
    contests: 'Contests',
    manageContest: 'Manage Contest',
    manageQuestions: 'Manage Questions',
    funNLearn: "Fun 'N' Learn",
    manageFunNLearn: "Manage Fun 'N' Learn",
    guessTheWord: 'Guess The Word',
    manageGuessTheWord: 'Manage Guess The Word',
    audioQuestions: 'Audio Questions',
    manageAudioQuestions: 'Manage Audio Questions',
    mathsQuiz: 'Maths Quiz',
    manageMathsQuestions: 'View Questions',
    examModule: 'Exam Module',
    importExamQuestion: 'Import Exam Question',
    leaderboard: 'Leaderboard'
  },
  experienceParentMenu: {
    experience: 'Experience',
    focuses: 'Focuses',
    focus: 'Focus',
    affirmation: 'Affirmation',
    meditation: 'Meditation',
    sleepSounds: 'Sleep',
    shoorahPods: 'Shoorah Pods',
    rituals: 'Habits',
    topPicks: 'Top Picks',
    visionBoardIdeas: 'Vision Board Ideas',
    breathWork: 'Breath-work',
    shoorahVids: 'Shoorah Vids',
    marketplace: 'Marketplace',
    selfAssessment: 'Self Assessment',
    healthVideos: 'Health Videos'
  },
  businessHubParentMenu: {
    businessHub: 'BusinessHub',
    b2bDashboard: 'B2B Dashboard',
    b2bCompanyList: 'B2B Company List',
    b2bEarnings: 'B2B Earnings',
    partnerList: 'Partner List',
    b2b: 'B2B',
    partners: 'Partners',
    partnerIntroduced: 'Partner Introduced',
    school: 'School'
  },
  shoorahHealth: {
    shoorahHealth: 'Shoorah Health',
    Dashboard: 'Dashboard',
    Fitness: 'Fitness',
    Nutrition: 'Nutrition',
    Categories: 'Workout Categories'
  },

  achievements: {
    achievements: 'Achievements',
    list: 'Achievements',
    create: 'Create Achievement'
  },

  Peptides: {
    Peptides: 'Peptides',
    dashboard: 'Dashboard'
  },

  schoolManagementParentMenu: {
    schoolManagement: 'School Management',
    overview: 'Overview',
    manageSchools: 'Manage Schools'
  },

  kidsManagementParentMenu: {
    kidsManagement: 'Kids Management',
    kids: 'Kids',
    kidsDashboard: 'Kids Dashboard',
    kidsPods: 'Mindfullness',
    affirmation: 'Affirmation',
    stories: 'Sleep'
  },
  payments: 'Payments',
  me: 'Me',
  clients: 'Clients',
  schedule: 'Schedule'
};

export const ContentApprovalPageData = {
  metaTitle: 'Content Approval | Shoorah Admin',
  title: 'Content Approval',
  tabTextAll: 'All',
  tabTextAwaitingApporval: 'Awaiting Approval',
  tabTextApproved: 'Approved',
  searchPlaceHolder: 'Search by name',
  filterText: 'Filters',
  resetFilterText: 'Reset Filter',
  closeText: 'Close',
  contentTypeText: 'Content type',
  approvalStatusText: 'Approval status',
  createdByText: 'Created by',
  updatedByText: 'Updated By',
  tableName: 'content_approval',
  approvalQuestion: 'Are you sure you want to approve?',
  rejectionReasonMessage: 'Enter a rejection reason to the creator',
  rejectPopUpTitle: 'Rejection reasoning',
  columnHeaderTitle: {
    name: 'Name',
    contentArea: 'Content Area',
    expertName: 'Expert Name',
    dateCreated: 'Date Created',
    createdBy: 'Created By',
    dateApproved: 'Date Approved',
    approvedBy: 'Approved By',
    status: 'Status',
    actions: 'Actions',
    draft: 'Draft',
    approved: 'Approved',
    rejected: 'Rejected',
    viewText: 'View',
    viewContentText: 'View Content',
    approveText: 'Approve',
    rejectText: 'Reject'
  },
  errorToastMessage: 'Tutorial not found'
};

export const CMSPageData = {
  metaTitle: 'CMS | Shoorah Admin',
  pageName: 'CMS',
  addCMS: 'Add CMS',
  cmsTitle: 'CMS Title',
  cmsTitlePlaceholder: 'Enter CMS Title',
  cmsAlias: 'CMS Alias',
  cmsAliasPlaceholder: 'Enter alias',
  saveBtnText: 'Save',
  addNewBtnText: 'Add New',
  title: 'Title',
  view: 'View',
  edit: 'Edit',
  updateErrorMessage: 'An error occurred while updating CMS content.',
  viewCMS: 'View CMS',
  editCMS: 'Edit CMS',
  submitBtnText: 'Submit',
  confirmUpdateMessage: 'Are you sure you want to update cms content?',
  enterDescription: 'Please enter description',
  enterTitle: 'Please enter title'
};

export const ConfigPageData = {
  metaTitle: 'Config | Shoorah Admin',
  pageName: 'Config',
  maintenanceMode: 'Maintenance Mode',
  ios: 'iOS',
  android: 'Android',
  website: 'Website',
  forceUpdate: 'Force Update',
  iosUpdateLabel: 'Minimum value for the iOS update',
  iosUpdateConfirmMessage: 'Are you sure you want to change iOS force update details?',
  androidUpdateLabel: 'Minimum value for the android update',
  androidUpdateConfirmMessage: 'Are you sure you want to change android force update details?',
  changeMaintananceConfirmMessage: 'Are you sure you want to change maintenance mode of',
  updateMessageLabel: 'Update Message',
  mandatoryForceUpdate: 'Mandatory force update',
  saveBtnText: 'Save',
  tutorialVideos: 'Tutorial Videos',
  tabs: {
    aboutShoorah: 'About Shoorah',
    cleanse: 'Cleanse',
    gratitude: 'Gratitude',
    goals: 'Goals',
    rituals: 'Rituals',
    notes: 'Notes',
    restore: 'Restore',
    journal: 'Journal',
    affirmation: 'Affirmation',
    pods: 'Pods',
    shuru: 'Shuru',
    breathwork: 'Breathwork',
    visions: 'Visions'
  },
  validImageErrorMessageBeforeFileName: 'The specified file',
  validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
  fileShouldBeLessThan1MB: 'File size should be less than 1MB',
  validVideoErrorMessageBeforeFileName: 'The specified file',
  validVideoErrorMessageafterFileName: 'could not be uploaded. Please upload valid video.',
  fileShouldBeLessThan500MB: 'File size should be less than 500MB',
  videoUploadedSuccessfully: 'Tutorial video uploaded successfully.',
  somethingWentWrong: 'Something went wrong',
  uploadVideoText: 'Upload video',
  deleteVideoText: 'Delete video',
  browseText: 'Browse',
  fileSizeUpto500MBMax: 'File size is upto 500 MB max.',
  vdideoFileType: 'mp4',
  uploadThumbnailText: 'Upload thumbnail',
  deleteThumbnailText: 'Delete thumbnail',
  fileSizeUpto1MBMax: 'File size is upto 1 MB max.',
  imageFileType: 'png, jpg, jpeg',
  durationText: 'Duration',
  headingLabel: 'Heading',
  subHeadingLabel: 'Sub Heading',
  enterMinimumAndroidVersion: 'Please enter minimum Android version.',
  enterValidMinimumAndroidVersion: 'Please enter valid minimum Android version.',
  enterMinimumIOSVersion: 'Please enter minimum iOS version.',
  enterValidMinimumIOSVersion: 'Please enter valid minimum iOS version.',
  enterUpdateMessage: 'Please enter update message.',
  duration: {
    minutesText: 'Minutes',
    minsText: 'mins',
    secondsText: 'Seconds',
    secText: 'sec'
  }
};

export const ConfirmPopUpContent = {
  confirm: 'Confirm',
  yesText: 'Yes',
  noText: 'No'
};

export const UserPageData = {
  pageName: 'Users',
  metaTitle: 'Users | Shoorah Admin',
  saveBtnText: 'Save',
  tableHeaderText: {
    profile: 'Profile',
    jobRole: 'Job Role',
    // The column answers "are they paying?", not "what kind of account".
    accountType: 'Subscription',
    emailOrMobileNotVerified: 'Email / Mobile Verified',
    signUpPlatform: 'Signup Platform',
    lastLogin: 'Last Login',
    registerdOn: 'Registered On',
    status: 'Status',
    uploadCsvErrorMessageBeforeFileName: 'The specified file',
    uploadCsvErrorMessageAfterFileName: 'could not be uploaded. Please upload CSV file only.',
    userSuccessfullyRegisteredMessage: 'Users successfully registered !',
    pleaseCheckDownloadReportErrorMessage:
      'Please check the downloaded report for the errors and try again!'
  },
  addUsersPopUp: {
    popUpTitle: 'Add Users',
    addAUserTitle: 'Add a user',
    importUsersTitle: 'Import users',
    firstNameLabel: 'First Name',
    firstNamePlaceHolder: 'Enter First Name',
    lastNameLabel: 'Last Name',
    lastNamePlaceHolder: 'Enter Last Name',
    genderLabel: 'Gender',
    genderDisabledOption: 'Select Gender',
    userEmailLabel: 'User Email',
    userEmailPlaceHolder: 'Enter Email',
    userPlatformLabel: 'User Platform',
    appleLabel: 'Apple',
    googleLabel: 'Google',
    othersLabel: 'Others',
    companyLabel: 'Company',
    companyDisabledOption: 'Company',
    jobRoleLabel: 'Job Role',
    jobRolePlaceHolder: 'Select Job Role',
    accountTypeLabel: 'Account Type',
    premiumLabel: 'Premium',
    basicLabel: 'Basic',
    dobLabel: 'DOB',
    dobPlaceHolder: 'Enter your date of birth',
    ethnicityLabel: 'Ethnicity',
    ethnicityDisabledOption: 'Select Ethnicity',
    downloadSampleFileText: 'Download sample file',
    fileLabel: 'File',
    validationMesage: {
      enterFirstNameMssage: 'Please enter the first name.',
      validFirstNameMessage: 'First name should contain only letters and spaces.',
      enterLastNameMessage: 'Please enter the last name.',
      validLastNameMessage: 'Last name should contain only letters and spaces.',
      enterEmailAddressMessage: 'Please enter the email address.',
      validEmailAddressMessage: 'Please enter a valid email address.'
    }
  },
  pleaseCheckDownloadReportErrorMessage:
    'Please check the downloaded report for the errors and try again!',
  userSuccessfullyRegisteredMessage: 'Users successfully registered !',
  perPageLabel: 'Per Page',
  searchPlaceHolder: 'Search',
  addUserBtnText: 'Add User',
  exportUsersBtnText: 'Export Users',
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    subscriptionStatusLabel: 'Subscription Status',
    accountStatusLabel: 'Account status',
    signUpPlatformLabel: 'Signup Platform',
    addedByLabel: 'Added by',
    addedByOption: [
      { name: 'All', value: null },
      { name: 'Super Admin', value: 'admin' },
      { name: 'Ripple', value: 'ripple' }
    ],
    roleLabel: 'Role',
    roleOption: [
      { name: 'All', value: null },
      { name: 'B2C', value: false },
      { name: 'B2B', value: true }
    ],
    jobRoleLabel: 'Job Role',
    jobRolePlaceHolder: 'Select Job Role'
  },
  tableName: 'users_table'
};

export const ViewUserPageData = {
  editUserMetaTitle: 'Edit User | Shoorah Admin',
  viewUserMetaTitle: 'View User | Shoorah Admin',
  editUserPageName: 'Edit User',
  viewUserPageName: 'View User',
  breadCrumbPageName: {
    usersPageName: 'Users',
    editUserPageName: 'Edit User Details',
    viewUserPageName: 'View User Details'
  },
  addtiralDaysBox: {
    title: 'Add Trial Days',
    addBtnText: 'Add',
    tabArray: [
      { name: 'user profile', value: 1 },
      { name: 'user data', value: 2 },
      { name: 'user wellbeing', value: 3 }
    ]
  },
  subscriptionRenewalUpdateStatusMessage: 'User subscription renewal status updated successfully',
  trialAddedToUserSuccessMessage: 'Trial added to user account successfully!',
  sendEmailSuccessMessage: 'Email Sent Successfully!',
  somethingWentWrongErrorMessage: 'Something went wrong!',
  formType: {
    trial: 'Trial',
    free: 'Free',
    paid: 'Paid',
    expired: 'Expired',
    none: '━━'
  },
  cancelRenewalBtnText: 'cancel renewal',
  resendCredentialsBtnText: 'Resend Credientials',
  fullnameLabel: 'Full name',
  fullNamePlaceHolder: 'Enter full name',
  companyLabel: 'Company',
  companyDisabledOption: 'Company',
  accountTypeLabel: 'Account Type',
  paidLabel: 'Paid',
  basicLabel: 'Basic',
  emailOrMobileLabel: 'Email / Mobile',
  genderLabel: 'Gender',
  noGenderValueLabel: 'Not Preferred',
  dobLabel: 'Date of birth',
  statusLabel: 'Status',
  activeStatus: 'Active',
  inActiveStatus: 'Inactive',
  loginPlatformLabel: 'Login Platform',
  loginPlatformType: {
    shoorah: 'Shoorah',
    apple: 'Apple',
    google: 'Google',
    facebook: 'Facebook'
  },
  addedByText: 'Added By :',
  wearableToogleText: 'Wearable',
  superAdminText: 'Super Admin',
  cancelBtnText: 'Cancel',
  saveBtnText: 'Save',
  userFeelPersonalMoodsText: 'User Feels - Personal Moods',
  selectMoodLabel: 'Select Mood:',
  noDataText: 'No data',
  userFeelProfessionalMoodsText: 'User Feels - Professional Moods',
  selectProfessionalMoodLabel: 'Select Professional Mood:',
  userFeelBeforeSleepLogsLabel: 'User Feels - Before Sleep Logs',
  selectBeforeSleepLabel: 'Select Before Sleep:',
  userFeelDuringSleepLogsText: 'User Feels - During Sleep Logs',
  selectDuringSleepLabel: 'Select During Sleep:',
  noResultMessage: 'No results',
  userDataTabBadgesSection: {
    badgeAltText: 'badge',
    badgeTitles: {
      bronze: 'BRONZE',
      silver: 'SILVER',
      gold: 'GOLD',
      platinum: 'PLATINUM',
      diamond: 'DIAMOND'
    },
    noTitleFoundMessage: 'No title found',
    noDescriptionFoundMessage: 'No description found',
    completedText: 'Completed',
    notCompletedText: 'Not completed',
    NoDataText: 'No data',
    notes: {
      text: 'Note:',
      message: 'Select badge to see badge data'
    }
  },
  userWellbeingTabSection: {
    headerText:
      'This is wellbeing section where you will see the user wellbeing statistics. You can see user growth statistics how shoorah helped them for build them positive mindset and prevented negative thoughts.',
    positive: 'positive',
    negative: 'negative',
    journalWellBeing: 'Journal wellbeing',
    shuruWellBeing: 'Shuru wellbeing',
    personalEmotionsWellbeing: 'Personal Emotions wellbeing',
    professionalEmotionsWellbeing: 'Professional Emotions wellbeing',
    journal: 'Journal',
    shuru: 'Shuru',
    affirmation: 'affirmation',
    gratitude: 'gratitude',
    goals: 'goals',
    cleanse: 'cleanse',
    notes: 'notes',
    oneMonth: '1 month',
    secondMonth: '2 month',
    thirdMonth: '3 month',
    fourMonth: '4 month',
    fifthMonth: '5 month',
    sixthMonth: '6 month',
    seventhMonth: '7 month',
    pageA: 'Page A',
    pageB: 'Page B',
    pageC: 'Page C',
    pageD: 'Page D',
    pageE: 'Page E',
    pageF: 'Page F',
    pageG: 'Page G',
    positive1: 'Positive',
    negative1: 'Negative',
    reportName: 'Overall Well Being  Report'
  }
};

export const ExpertPageData = {
  pageName: 'Experts',
  metaTitle: 'Experts | Shoorah Admin',
  editExpertText: 'Edit Experts',
  addExpertText: 'Add Experts',
  tableHeaderText: {
    profile: 'Profile',
    fullName: 'Full Name',
    expertType: 'Expert Type',
    description: 'Description',
    createdBy: 'Created By',
    createdAt: 'Created At',
    status: 'Status',
    action: 'Action'
  },
  uploadImgErrorMessageBeforeFileName: 'The specified file ',
  uploadImgErrorMessageAfterFileName: 'could not be uploaded. Please upload valid image.',
  expertUpdateSuccessMessage: 'Experts updated successfully',
  expertCreateSuccessMessae: 'Experts created successfully',
  uploadCsvErrorMessageBeforeFileName: 'The specified file',
  uploadCsvErrorMessageAfterFileName: 'could not be uploaded. Please upload CSV file only.',
  userRegisterdSuccessMessage: 'Users successfully registered !',
  userRegisterdErrorMessage: 'Please check the downloaded report for the errors and try again!',
  totalListenersText: 'Total Listeners :',
  fullnameLabel: 'Full Name',
  fullNamePlaceholder: 'Enter First Name',
  descriptionLabel: 'Description',
  updateBtnText: 'Update',
  submitBtnText: 'Submit',
  cancelBtnText: 'Cancel',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search',
  addExpertsBtnText: 'Add Expert',
  tableName: 'pod_expert_table',
  validationMessage: {
    enterFullNameMessage: 'Please enter the full name.',
    validFullNameMessage: 'Full name should contain only letters and spaces.'
  },
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    subscriptionStatusLabel: 'Subscription Status',
    accountStatusLabel: 'Account status',
    signUpPlatformLabel: 'Signup Platform',
    addedByLabel: 'Added by',
    addedByOption: [
      { name: 'All', value: null },
      { name: 'Super Admin', value: 'admin' },
      { name: 'Ripple', value: 'ripple' }
    ],
    roleLabel: 'Role',
    roleOption: [
      { name: 'All', value: null },
      { name: 'B2C', value: false },
      { name: 'B2B', value: true }
    ],
    jobRoleLabel: 'Job Role',
    jobRolePlaceHolder: 'Select Job Role'
  }
};

export const EditExpertPageData = {
  pageName: 'Experts',
  metaTitle: 'Partnership | Shoorah Admin',
  editExpertText: 'Edit Expert',
  addExpertText: 'Add Expert',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by user name',
  tableHeaderText: {
    listenAudio: 'Listen Audio',
    meditationName: 'Meditation Name',
    soundName: 'Sound Name',
    shoorahPodName: 'Shoorah Pod Name',
    breathworkName: 'Breathwork Name',
    duration: 'Duration',
    approvalStatus: 'Approval Status',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    playedMinutes: 'Played Minutes',
    mostPlayed: 'Mostly Played',
    rating: 'Rating',
    status: 'Status'
  },
  uploadImgErrorMessageBeforeFileName: 'The specified file ',
  uploadImgErrorMessageAfterFileName: 'could not be uploaded. Please upload valid image.',
  operationFailedErrorMessage: 'Operation failed. Please try again.',
  expertUpdateSuccessMessage: 'Experts updated successfully',
  expertCreateSuccessMessae: 'Experts created successfully',
  errorOccurredMessage: 'An error occurred. Please try again.',
  failedLoadExpertProfileMessage: 'Failed to load expert profile. Please try again.',
  errorOccurredWhileFetchProfileMessage: 'An error occurred while fetching expert profile.',
  failedToLoadDataMessage: 'Failed to load data. Please try again.',
  errorOccurredWhileFetchingDataMessage: 'An error occurred while fetching data.',
  fullnameLabel: 'Full Name',
  descriptionLabel: 'Description',
  expertTypeLabel: 'Expert Type',
  acccountStatusLabel: 'Account Status',
  updateBtnText: 'Update',
  submitBtnText: 'Submit',
  cancelBtnText: 'Cancel',
  tableName: 'pods_table'
};

export const SubAdminPageData = {
  pageName: 'Shoorah Admins',
  metaTitle: 'Shoorah Admins | Shoorah Admin',
  pageTitle: 'Shoorah Admins',
  tableHeaderText: {
    profile: 'Profile',
    userType: '	User Type',
    status: 'Status',
    lastLogin: 'Last login'
  },
  tutorialNotFoundErrorMessage: 'Tutorial not found',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search',
  addnewBtnText: 'Add Admin',
  filterModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    userTypeLabel: 'User type'
  },
  tableName: 'admin_table',
  infoPopUpText: 'Shoorah Admins'
};

export const AddEditSubAdminPageData = {
  subAdminText: 'Shoorah Admin',
  addSubAdminText: 'Add Admin',
  editSubAdminText: 'Edit Admin',
  editSubAdminMetaTitle: 'Edit Admin | Shoorah Admin',
  addSubAdminMetaTitle: 'Add Admin | Shoorah Admin',
  somethingWentWrongErrorMessage: 'Something went wrong',
  uploadImgErrorMessageBeforeFileName: 'The specified file ',
  uploadImgErrorMessageAfterFileName: 'could not be uploaded. Please upload valid image.',
  nameLabel: 'Name',
  emailLabel: 'Email address',
  userTypeLabel: 'User Type',
  statusLabel: 'Status',
  earningModuleAccessLabel: 'Earning Module Access',
  submitBtnText: 'Submit',
  cancelBtnText: 'Cancel',
  updateConfirmationMessage: 'Are you sure you want to update sub admin details?',
  validationMessage: {
    enterNameMessage: 'Please enter name.',
    enterEmailMessage: 'Please enter email address.',
    validEmailMessage: 'Please enter valid email address.',
    notAllowedEmailMessage: 'A disposable email address is not allowed.',
    pleaseSelectUserTypeMessage: 'Please select user type.'
  }
};

export const InfoPopUpModalData = {
  infoBtnText: 'Info',
  tutorialBtnText: 'Tutorial',
  assistantBtnText: 'Assistant',
  infoTabData: {
    whyText: 'Why?',
    whenText: 'When?',
    faqText: 'FAQ’s'
  },
  assistantTabData: {
    askTheAssistantText: 'Ask the assistant',
    getInstantGuidanceTtext: 'Get instant guidance & tips!',
    messageBeforeName: 'Hey ',
    messageAfterName: ' , how can I help?'
  }
};

export const PeapDashboardData = {
  metaTitle: 'Peap Dashboard',
  title: 'Peap Dashboard',
  photoRibbonText: 'Top Booked Specialist',
  drName: 'Dr. Esther Cooper',
  therapistText: 'Therapist',
  sessionBookedThisMonthText: 'Sessions Booked this month',
  sessionBookedNUmber: '125',
  sendAThankYouMessage: 'Send a Thank You Message',
  totalMemberSupportedText: 'Total Members Supported',
  totalSupportedCount: '15,567',
  totalSessionText: 'Total Session',
  totalSessionNumber: '3,546',
  workRelatedCasesText: 'Work Related Cases',
  workRelatedCasesNUmber: '546',
  wellPointsUsedText: 'WellPoints Used',
  wellPointsUsedDate: '1.01.2025 - Present Date',
  wellPointsUsedNumber: '45,000',
  increaseCompareToLastMonthMessage: '30% Increase compared to last month',
  sessionBookedByText: 'Session Booked By Job Grade',
  sessionText: 'Session',
  saleIncreaseText: 'Sale Increase',
  SaleIncreaseInNumber: '£1,500',
  saleIncreaseInPR: '15.01%',
  newCustomerText: 'New Customer',
  newCustomerCount: '125',
  newCustomerInPR: '21.01%',
  realTimeSession: 'Real-Times Session',
  realTimeSessionCount: '125',
  realTimeSessionInPR: '21.01%',
  mostPopularSessionText: 'Most Popular Session',
  ageText: 'Age',
  genderText: 'Gender',
  dataArea: [
    { name: '', value: 200 },
    { name: '', value: 133 },
    { name: '', value: 250 },
    { name: '', value: 176 },
    { name: '', value: 300 },
    { name: '', value: 420 },
    { name: '', value: 356 },
    { name: '', value: 180 }
  ],
  dataLine: [
    { label: 'Director', value: 36, color: 'bg-blue-500' },
    { label: 'Senior Manager', value: 24, color: 'bg-yellow-400' },
    { label: 'Manager', value: 31, color: 'bg-orange-400' },
    { label: 'Associate', value: 39, color: 'bg-green-400' },
    { label: 'Staff', value: 53, color: 'bg-pink-500' },
    { label: 'Producer', value: 32, color: 'bg-teal-400' }
  ],
  activePayingUserData: {
    therapy: 'Therapy',
    psychology: 'Psychology',
    counselling: 'Counselling'
  },
  activeGenderData: {
    male: 'Male',
    female: 'Female',
    other: 'Other'
  },
  agedata: {
    first: '18-24',
    second: '25-34',
    third: '35-44',
    fourth: '45+'
  },
  saleIncreaseDataLabels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
};

export const B2BWellPointsPageData = {
  metaTitle: 'PEAP B2B WellPoints | Shoorah Admin',
  pageTitle: 'Invoicing',
  pageDescription: 'This is an overview of invoice requests from B2B companies.',
  searchPlaceholder: 'Search by Email',
  submittedInvoiceText: 'Submitted Invoices',
  totalAmountPaidText: 'Total Amount Paid',
  totalPaidInvoicesText: 'Total Paid Invoices',
  overdueInvoicesText: 'Overdue Invoices',
  allInvoicesChipLabel: 'All Invoice',
  paidChipLabel: 'Paid',
  pendingChipLabel: 'Pending',
  imageUploadedSuccessfullyMessage: 'Image uploaded successfully',
  tableHeaderText: {
    orderID: 'Order ID',
    companyName: 'Company Name',
    dateReceived: 'Date received',
    amount: 'Amount',
    wellPoints: 'Wellpoints',
    status: 'Status',
    action: 'Action',
    viewInvoiceBtnText: 'View Invoice'
  },
  paymentStatusStrings: {
    paid: 'Paid',
    unPaid: 'Unpaid'
  },
  purchaseTypeStrings: {
    instantPurchase: 'Instant Purchase',
    invoice: 'Invoice'
  },
  approvePaymentPopUp: {
    documentRequriedMessage: 'Document is required',
    paymentApprovalmessage: 'Are you sure you want to approve payment?',
    imageFormatNotSupportedMessage: 'Image format not supported.',
    allowedFormatMessage: 'Only JPG, JPEG, and PNG formats are allowed.',
    confirmBtnText: 'Confirm',
    uploadDocumentLabel: 'Upload Docuement',
    markAsPaidBtnText: 'Mark As Paid',
    cancelBtnText: 'Cancel'
  },
  filterModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    transactionTypeLabel: 'Transaction Type',
    statusLabel: 'Status',
    chooseTimePeriodLabel: 'Choose time period',
    chooseDateforFilteringPlaceholder: 'Choose the dates for filtering',
    applyFilterBtnText: 'Apply Filter'
  }
};

export const B2BWellPointsViewInvoicePageData = {
  metaTitle: 'Invoice Details | Shoorah Admin',
  pageTitle: 'Invoicing',
  pageDescription: 'This is an overview of invoice requests from B2B companies.',
  companyDetailsTitle: 'Company details',
  companyDetailsDescription: 'These are the company details',
  companyNameLabel: 'Company name',
  companyNamePlaceholder: 'Company name',
  emailLabel: 'Email',
  emailPlaceholder: 'Email address',
  companyEmailPlaceholder: 'Company email address',
  invoiceDetailsTitle: 'Invoice details',
  invoiceDetailsDescription:
    'This company has requested an invoice. Please use the following details to create it.',
  nameLabel: 'Name',
  namePlaceholder: 'Name',
  addressLabel: 'Address',
  addressPlaceholder: 'Address',
  attachedInvoiceOrPreviewTitle: 'Attached Invoice/Preview',
  attachedInvoiceOrPreviewDescription:
    "You have attached a file, which will also be visible on the company's side.",
  fileSizeLessThan5MBMessage: 'File size should be less than 5MB',
  downloadFileBtnText: 'Download file',
  addNewFileBtnText: 'Add new file',
  replaceFileBtnText: 'Replace file',
  fileSizeText: 'File size:',
  pleaseAttachedInvoiceMessage: 'Please attach the invoice',
  attachedFileVisibleInCompanySideMessage:
    "You have attached a file, which will also be visible on the company's side.",
  additionalDetailsText: 'Additional details',
  additionalDetailsDescription:
    'You can add additional details. Please note, these will also be visible to the company.',
  invoiceNumberLabel: 'Invoice number',
  invoiceNumberPlaceholder: 'Invoice number',
  amountLabel: 'Amount (£)',
  amountPlaceholder: 'Amount',
  saveDetailsBtnText: 'Save details',
  internalStatusLabel: 'Internal status',
  internalStatusDescription:
    'Update the status of this invoice to ensure we can confirm payment from the company.',
  unpaidStaustext: 'Unpaid',
  paidStatusText: 'Paid',
  updateStatusBtnText: 'Update status',
  wellPointsLabel: 'Wellpoints information',
  wellPointsDescription:
    'This company has requested an invoice for an order of wellpoints. Once payment is confirmed, the wellpoints can be released to the company.',
  totalrequstText: 'Total requested:',
  wellPointsText: 'Wellpoints',
  totalAmountText: 'Total amount:',
  currencySign: '£',
  confirmCommunicationLabel: 'Confirm communication',
  confirmCommunicationDescription:
    'Please confirm that you have also emailed the invoice to the listed email address provided in the request.',
  markedAsEmailedCompanyText: 'Mark as emailed company',
  updateStatusDialogTitle: 'Update status',
  updateStatusConfirmMessage: 'Are you sure you want to update the status of this invoice?',
  markAsPaidBtnText: 'Mark As Paid',
  cancelBtnText: 'Cancel',
  invoiceNumberRequiredMessage: 'Invoice number is required',
  invoiceAmountRequriedMessage: 'Invoice amount is required',
  fileRequriedMessage: 'File is required',
  statusRequriedMessage: 'Status is required',
  imageUploadedSuccessMessage: 'Image uploaded successfully',
  statusUpdatedSuccessMessage: 'Status updated successfully',
  fileSizeLessThan30MBMessage: 'File size should be less than 30MB'
};

export const SpecialistPageData = {
  metaTitle: 'Peap Management',
  activeSpecialistTabData: {
    tabTitle: 'Specialist List',
    tabDescription: 'A quick snapshot of all specialist.',
    accountActivatedSuccessMessage: 'Account activated successfully',
    accountDeactivatedSuccessMessage: 'Account deactivated successfully',
    accountPausedSuccessMessage: 'Account paused successfully',
    tableHeaderText: {
      specialistName: 'Specialist Name',
      email: 'Email',
      sessions: 'Sessions',
      dateJoined: 'Date Joined',
      clients: 'Clients',
      status: 'Status',
      complaints: 'Complaints',
      rating: 'Rating',
      price: 'Price',
      identity: 'Identity',
      dbs: 'DBS',
      unreadMessages: 'Unread Massages',
      action: 'Action',
      actionMenuOptions: {
        select: 'Select',
        active: 'Active',
        reActivate: 'Reactivate',
        deActivate: 'Deactivate',
        pause: 'Pause'
      }
    },
    confirmationMessages: {
      2: `Are you sure you want to pause this expert?`,
      1: `Are you sure you want to deactivate this expert?`,
      0: `Are you sure you want to activate this expert?`
    }
  },
  specialistProfilePageData: {
    metaTitle: 'Peap Profile | Shoorah Admin',
    pageTitle: 'Specialist Profile',
    confirmationMessages: {
      2: `Are you sure you want to invite this expert?`,
      3: `Are you sure you want to approve this expert?`,
      4: `Are you sure you want to decline this expert?`,
      5: `Are you sure you want to join the interview?`
    },
    statusText: 'Status:',
    actionsText: 'Actions',
    profileCardData: {
      cardTitle: 'Personal details',
      titleText: 'Title:',
      nameText: 'Name:',
      dateOfBirthText: 'Date of birth:',
      locationText: 'Location:'
    },
    introVideoCardData: {
      cardTitle: 'Introduction Video',
      cardDescription: 'View a short video for clients to view (optional)',
      browserDoesNotSupportMessage: 'Your browser does not support the video tag.',
      noDataMessage: 'There is nothing to show here.'
    },
    personalBioCardData: {
      cardTitle: '’s Bio',
      cardDescriptionBeforeName: 'This is',
      cardDescriptionAfterName: '’s personal bio, this can be seen by users.',
      personalBioText: 'Personal bio'
    },
    pricingCardData: {
      cardTitle: 'Session Price',
      cardDescriptionBeforeName: 'This is the price that',
      cardDescriptionafterNameforCostApproved: 'will get',
      cardDescriptionafterNameforCostNotApproved: 'will request',
      namePriceString: '’s Price',
      currencySign: '£',
      publicPriceLabel: 'Public Price',
      approveText: 'Approve',
      rejectText: 'Reject',
      confirmMessage: {
        beforeNameText: 'Are you sure you want to approve ',
        betweenNameAndPriceText: '’s price of £',
        afterPriceText: ' per session? The public price will be £'
      },
      expertPriceNotGreaterThanPublicPriceMessage:
        'Expert price cannot be greater than public price',
      updatePriceSuccessMessage: 'Price updated successfully',
      updatePriceErrorMessage: 'Failed to update price',
      updatePriceBtnText: 'Update Price',
      updatingPriceBtnText: 'Updating...'
    },
    informationCardData: {
      cardTitle: 'Client Viewable Information',
      cardDescription: 'This information is visible to users',
      medicalIDNumberLabel: 'Medical ID Number',

      placeOfEducationLabel: 'Place of Education',
      socialURLLabel: 'Social URL',
      yearOfExperienceLabel: 'Years of Experience',
      educationLabel: 'Education'
    },
    specificationCardData: {
      cardTitle: 'Specialisations',
      cardDescriptionBeforeFirstName: 'These highlight',
      cardDescriptionAfterFirstName: '’s specialisations'
    },
    dbsInfoCardData: {
      cardTitle: 'DBS Check',
      cardDescription: {
        beforeFirstName: 'This provides an overview of',
        betweenFirstName: '’s DBS and identity verification. You only need to approve or reject',
        afterFirstName: '’s DBS documents.'
      },
      dbsDocumentationText: 'DBS Documentation:',
      noDocumentAvailable: 'No document available',
      approvedText: 'Approved',
      rejectBtnText: 'Reject',
      approveBtnText: 'Approve'
    },
    idVerificationCardData: {
      cardTitle: 'ID Verification',
      cardDescription: {
        beforeFirstName: 'This provides an overview of ',
        betweenFirstName: '’s identity verification documents. You only need to approve or reject ',
        afterFirstName: '’s submission.'
      },
      documentText: 'Document',
      approvedText: 'Approved',
      rejectBtnText: 'Reject',
      approveBtnText: 'Approve',
      noDocumentAvailable: 'No identity document available',
      onFidoVerificationText: 'Onfido Identification:',
      verificationText: 'Verified',
      rejectText: 'Rejected'
    },
    attachmentsCardData: {
      cardTitle: 'Attachments',
      cardDescription:
        ' Easily attach documents to your profile. Any updated files will need to undergo approval before being finalised.',
      certificationDocumentsLabel: 'Certification Documents:',
      insuranceDoumentsLabel: 'Insurance Documents:',
      resumeDocumentsLabel: 'Resume Document:',
      legalSentLabel: 'Legals Sent:',
      legalAcceptedLabel: 'Legals Accepted:',
      approvedText: 'Approved',
      rejectBtnText: 'Reject',
      approveBtnText: 'Approve'
    }
  },
  pendingSpecialistTabData: {
    tabTitle: 'Pending Specialist',
    tabDescription: 'A quick snapshot of all specialists who are waiting to join Shoorah.',
    confirmationMessages: {
      2: `Are you sure you want to invite this expert?`,
      3: `Are you sure you want to approve this expert?`,
      4: `Are you sure you want to decline this expert?`,
      5: `Are you sure you want to join the interview?`
    },
    tableHeaderText: {
      name: 'Name',
      email: 'Email',
      dateJoined: 'Date Joined',
      status: 'Status',
      action: 'Action',
      selectText: 'Select'
    }
  },
  complaintTabData: {
    metaTitle: 'Specialist Shoorah Admin',
    tabList: {
      all: 'All',
      resolved: 'Resolved',
      unresolved: 'Unresolved'
    },
    tableHeaderText: {
      userEmailAddress: 'User Emial Address',
      complaint: 'Complaint',
      complaintAgainst: 'Complaint Against',
      date: 'Date',
      resolved: 'Resolved?'
    },
    tableData: [
      {
        email: 'esthercooper@shoorah.io',
        complaint: "I'm appaled at the way...",
        name: 'Dr. Esther Cooper',
        date: '24 April, 2024',
        checked: true,
        id: 1
      },
      {
        email: 'esthercooper@shoorah.io',
        complaint: "I'm appaled at the way... ",
        name: 'Dr. Esther Cooper',
        date: '24 April, 2024',
        checked: false,
        id: 2
      },
      {
        email: 'esthercooper@shoorah.io',
        complaint:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry.' +
          '\n\n' +
          "Lorem Ipsum has been the industry's standard dummy. Lorem Ipsum is simply dummy text of the printing and typesetting industry.\n\nLorem Ipsum has been the industry's standard dummy. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
        name: 'Dr. Esther Cooper',
        date: '24 April, 2024',
        checked: true,
        id: 3
      },
      {
        email: 'esthercooper@shoorah.io',
        complaint: "I'm appaled at the way...",
        name: 'Dr. Esther Cooper',
        date: '24 April, 2024',
        checked: true,
        id: 4
      },
      {
        email: 'esthercooper@shoorah.io',
        complaint: "I'm appaled at the way...",
        name: 'Dr. Esther Cooper',
        date: '24 April, 2024',
        checked: false,
        id: 5
      },
      {
        email: 'esthercooper@shoorah.io',
        complaint: "I'm appaled at the way...",
        name: 'Dr. Esther Cooper',
        date: '24 April, 2024',
        checked: true,
        id: 6
      }
    ],
    complaintModalData: {
      complaintText: 'Complaint',
      userEmailText: 'User Email:',
      dateRaisedText: 'Date Raised:',
      complainant: 'Complainant:',
      respondViaEmailText: 'Respond via email'
    }
  },
  messagingTabData: {
    searchPlaceholder: 'Search',
    therapistText: 'Therapist',
    initialChats: [
      {
        name: 'Dr. Millie Hale',
        lastMessage: 'Hi there, I have some concerns...',
        messages: [
          {
            text: "Hi Dr. Smith, welcome to Shoorah! I see you've completed your profile and uploaded your DBS and ID checks...",
            time: '09:35am',
            sender: 'me'
          },
          {
            text: 'Hey Lorri, Im glad the verification process went smoothly. Actually, could you please help me update the "Specialisation" section on my profile?',
            time: '09:57am',
            sender: 'them'
          }
        ]
      },
      {
        name: 'Dr. John Doe',
        lastMessage: 'Can we reschedule our meeting?',
        messages: [{ text: 'Can we reschedule our meeting?', time: '10:00am', sender: 'them' }]
      },
      {
        name: 'Dr. John Doe',
        lastMessage: 'Can we reschedule our meeting?',
        messages: [{ text: 'Can we reschedule our meeting?', time: '10:00am', sender: 'them' }]
      },
      {
        name: 'Dr. John Doe',
        lastMessage: 'Can we reschedule our meeting?',
        messages: [{ text: 'Can we reschedule our meeting?', time: '10:00am', sender: 'them' }]
      },
      {
        name: 'Dr. John Doe',
        lastMessage: 'Can we reschedule our meeting?',
        messages: [{ text: 'Can we reschedule our meeting?', time: '10:00am', sender: 'them' }]
      },
      {
        name: 'Dr. John Doe',
        lastMessage: 'Can we reschedule our meeting?',
        messages: [{ text: 'Can we reschedule our meeting?', time: '10:00am', sender: 'them' }]
      },
      {
        name: 'Dr. John Doe',
        lastMessage: 'Can we reschedule our meeting?',
        messages: [{ text: 'Can we reschedule our meeting?', time: '10:00am', sender: 'them' }]
      },
      {
        name: 'Dr. John Doe',
        lastMessage: 'Can we reschedule our meeting?',
        messages: [{ text: 'Can we reschedule our meeting?', time: '10:00am', sender: 'them' }]
      },
      {
        name: 'Dr. John Doe',
        lastMessage: 'Can we reschedule our meeting?',
        messages: [{ text: 'Can we reschedule our meeting?', time: '10:00am', sender: 'them' }]
      },
      {
        name: 'Dr. John Doe',
        lastMessage: 'Can we reschedule our meeting?',
        messages: [{ text: 'Can we reschedule our meeting?', time: '10:00am', sender: 'them' }]
      }
    ]
  },
  approvalTabData: {
    metaTitle: 'Specialist Shoorah Admin',
    filterBtnText: 'Filter',
    searchPlaceholder: 'Search',
    filtersModal: {
      filtersBtnText: 'Filters',
      resetFiltersBtnText: 'Reset Filter',
      closeBtnText: 'Close',
      subscriptionStatusLabel: 'Subscription Status',
      accountStatusLabel: 'Account status',
      signUpPlatformLabel: 'Signup Platform',
      addedByLabel: 'Added by',
      addedByOption: [
        { name: 'All', value: null },
        { name: 'Super Admin', value: 'admin' },
        { name: 'Ripple', value: 'ripple' }
      ],
      roleLabel: 'Role',
      roleOption: [
        { name: 'All', value: null },
        { name: 'B2C', value: false },
        { name: 'B2B', value: true }
      ],
      jobRoleLabel: 'Job Role',
      jobRolePlaceHolder: 'Select Job Role'
    },
    tableHeaderText: {
      specialistName: 'Specialist Name',
      requestType: 'Request Type',
      clientName: 'Client Name',
      date: 'Date',
      approveOrdecline: 'Approve/Decline'
    },
    tableData: [
      {
        name: 'Dr. Esther Cooper',
        request: 'Request to send document to client',
        clientname: 'Ruben Hale',
        date: '24 April, 2024',
        id: 1,
        align: 'center'
      },
      {
        name: 'Dr. Esther Cooper',
        request: 'Request to send document to client',
        clientname: 'Ruben Hale',
        date: '24 April, 2024',
        id: 2,
        align: 'center'
      },
      {
        name: 'Dr. Esther Cooper',
        request: 'Request to send document to client',
        clientname: 'Ruben Hale',
        date: '24 April, 2024',
        id: 3,
        align: 'center'
      },
      {
        name: 'Dr. Esther Cooper',
        request: 'Request to send document to client',
        clientname: 'Ruben Hale',
        date: '24 April, 2024',
        id: 4,
        align: 'center'
      },
      {
        name: 'Dr. Esther Cooper',
        request: 'Request to send document to client',
        clientname: 'Ruben Hale',
        date: '24 April, 2024',
        id: 5,
        align: 'center'
      },
      {
        name: 'Dr. Esther Cooper',
        request: 'Request to send document to client',
        clientname: 'Ruben Hale',
        date: '24 April, 2024',
        id: 6,
        align: 'center'
      }
    ]
  },
  paymentTabData: {
    submittedInvoiceText: 'Submitted Invoices',
    totalAmountPaidText: 'Total Amount Paid',
    totalPaidInvoicesText: 'Total Paid Invoices',
    overdueInvoicesText: 'Overdue Invoices',
    allInvoicesChipLabel: 'All Invoice',
    paidChipLabel: 'Paid',
    pendingChipLabel: 'Pending',
    imageUploadedSuccessfullyMessage: 'Image uploaded successfully',
    tableHeaderText: {
      name: 'Name',
      invoiceID: 'Invoice ID',
      dateReceived: 'Date received',
      amount: 'Amount',
      email: 'Email',
      status: 'Status',
      action: 'Action',
      viewInvoiceBtnText: 'View Invoice'
    },
    paymentStatusStrings: {
      paid: 'Paid',
      unPaid: 'Unpaid'
    },
    approvePaymentPopUp: {
      paidAmountRequriedMessage: 'Paid Amount is required',
      invoiceNumberRequriedMessage: 'Invoice Number is required',
      documentRequriedMessage: 'Document is required',
      paymentApprovalmessage: 'Are you sure you want to approve payment?',
      imageFormatNotSupportedMessage: 'Image format not supported.',
      allowedFormatMessage: 'Only JPG, JPEG, and PNG formats are allowed.',
      confirmBtnText: 'Confirm',
      uploadDocumentLabel: 'Upload Docuement',
      markAsPaidBtnText: 'Mark As Paid',
      cancelBtnText: 'Cancel',
      paidAmountLabel: 'Paid Amount',
      paidAmountPlaceholder: 'Enter Paid Amount',
      invoiceNumberLabel: 'Invoice Number',
      invoiceNumberPlaceholder: 'Enter Paid Amount',
      notesLabel: 'Notes',
      notesPlaceholder: 'Enter Paid Amount',
      payNowBtnText: 'Pay Now'
    }
  }
};

export const pulseSurveyPageData = {
  pageTitle: 'Pulse Surveys',
  createNewSurveyBtnText: 'Create New Survey',
  viewAllBtnText: 'View All',
  myRecentSurveyText: 'My Recent Surveys',
  myTempletesText: 'My Templates',
  pulseSurveysTitle: 'Pulse Surveys',
  tutorialNotFoundMessage: 'Tutorial not found',
  unknownErrorOccuredMessage: 'Unknown Error Occurred',
  createdSurveysLabel: 'Created Surveys',
  activeSurveysLabel: 'Active Surveys',
  completedSurveysLabel: 'Completed Surveys',
  responseRateLabel: 'Response Rate',
  createNewSurveyPopUp: {
    heading: 'How do you want to create your survey?',
    startFromScratch: {
      title: 'Start from scratch',
      description: 'Begin with a blank survey of form, then add your questions'
    },
    useATemplate: {
      title: 'Use a template',
      description: 'Save time with a template built for your situation.'
    },
    createNewSurvey: {
      title: 'Create New Survey',
      description: 'Begin with a blank survey of form, then add your questions'
    },
    createNewTemplate: {
      title: 'Create a new Template',
      description: 'Create new templates for the B2B companies'
    }
  },
  surveyCardData: {
    editBtnText: 'Edit',
    resultsBtnText: 'Results',
    deleteBtnText: 'Delete',
    deActivateBtnText: 'Deactivate',
    sharedAsSurveyBtnText: 'Share as Survey',
    usedByTextBeforeCount: 'Used by ',
    responseTextAfterCount: ' responses'
  },
  overAllResponsesData: {
    title: 'Overall Responses',
    responseText: 'Responses',
    noResponseText: 'No Response'
  },
  averageCompetitionTimeText: 'Average Completion Time',
  minutesText: 'minutes',
  last7DaysText: 'Last 7 days',
  completionRateText: 'Completion Rate',
  topPerformingTemplateText: 'Top Performing Template',
  noPerformingTemplateText: "You Don't have any top performing template",
  percentageOfIncompleteSurveysText: 'Percentage of incomplete Surveys',
  weeklyUsageText: 'Weekly Usage',
  usersText: 'users',
  surveyMonthlyAnalysisText: 'Survey Monthly Analysis',
  percentageOfIncompleteAssessmentText: 'Percentage of incomplete Assessments',
  dropOffPointText: 'Drop-off point',
  introText: 'Intro',
  incompleteText: 'Incomplete',
  completedText: 'Completed',
  addSurveyPageData: {
    createSurveyTitle: 'Create Survey ',
    editSurveyTitle: 'Edit Survey',
    imageFormatNotSupportedMessage: 'Image format not supported.',
    imageUploadedSuccessmessage: 'Image uploaded successfully',
    pleaseAddQuestionErrorMessage: 'Please add question.',
    selectQuestionTypeErrorMessage: 'Please select question type.',
    addAtLeastOneValidAnswerErrorMessage: 'Please add at least one valid answer choice.',
    questionAddedSuccessMessage: 'Question added successfully.',
    lastAnswerremoveErrorMessage: 'Cannot remove the last answer field',
    surveyUpdatedSuccessMessage: 'Survey updated successfully',
    surveyCreateSuccessMessage: 'Survey created successfully',
    noFileProvideErrorMessage: 'No file provided',
    inputMustBeInFileObjectErrorMessage: 'Input must be a File object',
    uploadFailedWithStatusErrorMessage: 'Upload failed with status: ',
    titleIsRequriedMessage: '*Title is required',
    approvalByRequriedMessage: '*Approval by is required',
    viewBtnText: 'View',
    editBtnText: 'Edit',
    shareBtnText: 'Share',
    resultsBtnText: 'Results',
    insightsBtnText: 'Insights',
    previewBtnText: 'Preview',
    surveyLabel: 'Survey',
    templateLabel: 'Template',
    logoLabel: 'Logo',
    titleLabel: 'Title',
    titlePlaceHolder: 'Enter title: e.g Social Anxiety Assessment',
    categoryLabel: 'Category',
    descriptionLabel: 'Description',
    descriptionPlaceholder:
      'Enter description: e.g Take this assessment to find out if you may have symptoms of social anxiety.',
    questionSign: 'Q',
    deleteBtnText: 'Delete',
    duplicateBtnText: 'Duplicate',
    multipleChoiceQuestionPlaceholder: 'Enter Multiple Choice Question',
    characterLimitText: 'Character limit',
    addQuestionLabel: 'Add Question',
    addQuestionPlaceholder: 'Enter your question',
    selectTypeOption: {
      default: 'Select Type',
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      inputFieldText: 'Input Field'
    },
    answerChoicesLabel: 'Answers Choices',
    addOtherAnswerChoicesText: 'Add "Other" Answers Choice',
    answerChoicesPlaceholder: 'Enter your answer choice',
    bulkAnswersBtnText: 'Bulk Answers',
    skipableQuestionLabel: '"Skipable" Question',
    noneOfTheAboveOptionLabel: '"None of the Above" Options',
    saveQuestionBtnText: 'Save Question',
    submitBtnText: 'Submit',
    saveAsDraftBtnText: 'Save as draft',
    noDataFoundText: 'No data found'
  },
  shareSurveyPageData: {
    title: 'Share Survey',
    selectTeam: 'Select Team',
    businessToCustomerB2BLabel: 'Business to Customer (B2B)',
    businessToCustomerB2CLabel: 'Business to Customer (B2C)',
    allText: 'All ',
    teamText: 'Team',
    stafftext: 'Staff',
    membertext: ' Members',
    allTeamMembersText: 'All Team Members',
    allStaffMembersText: 'All Staff Members',
    selectCategory: 'Select Category',
    addEmailText: 'Add Email',
    addEmailPlaceholder: 'Enter email address',
    addCoverImagelabel: 'Add cover image',
    optionalText: '(Optional)',
    dropYourImageText: 'Drop your image here, or',
    browseText: 'browse',
    maximumFileSize5MBText: 'Maximum file size: 5MB',
    publishTimeAndAreaLabel: 'Publish Time and area',
    addDateLabel: 'Add Date',
    setDateLabel: 'Set Date',
    addTimeLabel: 'Add Time',
    setTimeLabel: 'Set Time',
    endPageText: 'End Page',
    headerTextLabel: 'Heading Text',
    headerTextPlaceholder: 'You have completed this survey.',
    bodyTextLabel: 'Body Text',
    bodyTextPlaceholder: 'Thank you for taking time to answer this survey.',
    sendSurveyBtnText: 'Send Survey',
    successfullyCreatedFirstTemplateMessage:
      'Congratulations on successfully creating your first survey template.',
    manageSurveyAndAccessInsightsMessage:
      'You can now manage this survey and access valuable insights',
    templatetext: 'Template'
  },
  resultPageData: {
    questionSign: 'Q',
    respondentText: 'Respondent',
    noChartDataText: 'This Chart has no data',
    hideChartBtnText: 'Hide Chart',
    showChartBtnText: ' Show Chart'
  },
  bulkAnswerModalData: {
    title: 'Add Answers in Bulk',
    description: 'Enter each answer choice on a seperate line',
    characterLimitText: 'Character limit',
    cancelBtnText: 'Cancel',
    saveBtnText: 'Save'
  },
  successModalData: {
    successMessages: {
      sendingSurveyToYourStaff: 'Congratulation on successfully sending survey to your staff!',
      surveyHasBeenDraft: 'Your survey has been drafted successfully!',
      creatingTemplate: 'Congratulation on creating Template Successfully!'
    },
    manageSurveyAndAccessInsightsMessage:
      'You can now manage this survey and access valuable insights',
    mySurveyText: 'My Surveys',
    myTemplateText: 'My Template'
  },
  approvalModalData: {
    sendrequestBtnText: 'Send Request',
    selectAdminPlaceholder: 'Select Admin...',
    sendSurveyToAdminMessage: 'Send the survey to an admin to gain approval',
    unableToShareThisSurveyMessage: "You're currently unable to share this survey"
  },
  insightsPageData: {
    weeklyUsageText: 'Weekly Usage',
    surveyMonthlyAnalysisText: 'Survey Monthly Analysis',
    completeText: 'Complete',
    completedText: 'Completed',
    notCompletedText: 'Not Completed',
    ageRangeDataLabels: {
      age18To25: 'Age: 18-25',
      age26To32: 'Age: 26-32'
    },
    commonOutComeDataLabels: {
      anxiety: 'Anxiety',
      depression: 'Depression'
    },
    topTimeUseDataLabels: {
      nineToTen: '9-10pm',
      sevenToEight: '7-8am'
    },
    averageScoreDataLabels: {
      label1: '30-40%',
      label2: '40-50%'
    },
    usersCompletedTitle: 'Users Completed',
    userAgeRangeTitle: 'User Age Range',
    commonOutComeTitle: 'Common Outcome',
    topUsageTimesTitle: 'Top Usage Times',
    averageScoreTitle: 'Average Scores',
    totalResponseText: 'Total Response',
    completionRateText: 'Completion rate',
    timeSpentText: 'Time Spent',
    skippedOptionsText: 'Skipped Questions',
    percentageOfIncompleteAssessmentText: 'Percentage of incomplete Assessments',
    usersText: 'users'
  },
  insightsB2BPageData: {
    weeklyUsageText: 'Weekly Usage',
    surveyMonthlyAnalysisText: 'Survey Monthly Analysis',
    completedText: 'Completed',
    completeText: 'Complete',
    notCompletedText: 'Not Completed',
    incompleteText: 'Incomplete',
    introText: 'Intro',
    userAgeRange: {
      age18To25: 'Age: 18-25',
      age26To32: 'Age: 26-32',
      age32To40: 'Age 32-40',
      ageAbove40: 'Age 40+'
    },
    gender: {
      male: 'Male',
      female: 'Female'
    },
    topUsagesTimes: {
      label1: '12am-6am',
      label2: '6am-12pm',
      label3: '12pm-6pm',
      label4: '6pm-12pm'
    },
    departmentOutcomeData: {
      marketing: 'Marketing',
      fianance: 'Finance',
      it: 'IT',
      hr: 'HR'
    },
    ageRangeDataLabels: {
      age18To25: 'Age: 18-25',
      age26To32: 'Age: 26-32'
    },
    commonOutComeDataLabels: {
      anxiety: 'Anxiety',
      depression: 'Depression'
    },
    topTimeUseDataLabels: {
      nineToTen: '9-10pm',
      sevenToEight: '7-8am'
    },
    averageScoreDataLabels: {
      label1: '30-40%',
      label2: '40-50%'
    },
    completedSurveysLabel: 'Completed Surveys',
    usersCompletedTitle: 'Users Completed',
    userAgeRangeTitle: 'User Age Range',
    commonOutComeTitle: 'Common Outcome',
    topUsageTimesTitle: 'Top Usage Times',
    averageScoreTitle: 'Average Scores',
    totalResponseText: 'Total Response',
    completionRateText: 'Completion rate',
    userRangeText: 'User Range',
    timeSpentText: 'Time Spent',
    skippedOptionsText: 'Skipped Questions',
    percentageOfIncompleteAssessmentText: 'Percentage of incomplete Assessments',
    usersText: 'users',
    maxAgeRangeText: 'Max Age range',
    genderOutComeText: 'Gender Outcome',
    genderText: 'Gender',
    maxTimeText: 'Max time rng',
    departmentOutComeText: 'Departments Outcome',
    maxDepartmentText: 'Max department',
    dropOffPointText: 'Drop-off point'
  },
  pulseSurveyTablePageData: {
    pageTitle: 'Pulse Surveys',
    createNewSurveyPopUp: {
      heading: 'How do you want to create your survey?',
      startFromScratch: {
        title: 'Start from scratch',
        description: 'Begin with a blank survey of form, then add your questions'
      },
      useATemplate: {
        title: 'Use a template',
        description: 'Save time with a template built for your situation.'
      },
      createNewSurvey: {
        title: 'Create New Survey',
        description: 'Begin with a blank survey of form, then add your questions'
      },
      createNewTemplate: {
        title: 'Create a new Template',
        description: 'Create new templates for the B2B companies'
      }
    },
    filtersModal: {
      filtersBtnText: 'Filters',
      resetFiltersBtnText: 'Reset Filter',
      closeBtnText: 'Close',
      subscriptionStatusLabel: 'Subscription Status',
      accountStatusLabel: 'Account status',
      signUpPlatformLabel: 'Signup Platform',
      addedByLabel: 'Added by',
      addedByOption: [
        { name: 'All', value: null },
        { name: 'Super Admin', value: 'admin' },
        { name: 'Ripple', value: 'ripple' }
      ],
      roleLabel: 'Role',
      roleOption: [
        { name: 'All', value: null },
        { name: 'B2C', value: false },
        { name: 'B2B', value: true }
      ],
      jobRoleLabel: 'Job Role',
      jobRolePlaceHolder: 'Select Job Role'
    },
    unknownErrorOccuredMessage: 'Unknown Error Occurred',
    perPageText: 'Per Page',
    searchPlaceholder: 'Search',
    dateCreatedText: 'Date created',
    createNewSurveyBtnText: 'Create New Survey',
    subScriptionStatusLabel: 'subscriptionStatus',
    activeDeactivateConfirmMessages: {
      inactiveMessage: 'Are you sure you want to inactive this survey?',
      activeMessage: 'Are you sure you want to active this survey?',
      deleteMessage: 'Are you sure you want to delete this survey?'
    },
    approvedText: 'Approved',
    notApprovedText: 'Not Approved',
    inactivateText: 'INACTIVE',
    completedText: 'Completed: ',
    incompleteText: 'Incomplete:',
    deliveredText: 'Delivered:',
    openText: 'Open:',
    sharedAsSurveyBtnText: 'Share as Survey',
    resultBtnText: 'Result',
    editBtnText: 'Edit',
    previewBtnText: 'Preview',
    deActivateBtnText: 'Deactivate',
    deleteBtnText: 'Delete',
    tableHeaderText: {
      name: 'Name',
      createdBy: 'Created By',
      createdOn: 'Created On',
      usedTime: 'Used Times',
      approvalStaus: 'Approval Status',
      approvedBy: 'Approved By',
      approvedOn: 'Approved On',
      insights: 'Insights',
      status: 'Status',
      actions: 'Actions'
    }
  }
};

export const InstantSupportPageData = {
  pageTitle: 'Instant Support (EAP)',
  metaTitle: 'Instant Support | Shoorah Admin',
  planIDs: {
    0: 'Telephonic EAP',
    1: 'Face-to-Face & Video EAP',
    2: 'Shoorah RISE Plan'
  },
  tableHeaderText: {
    name: 'Name',
    payment: 'Payment',
    datePaid: 'Date Paid',
    status: 'Status'
  },
  companyInstantSupportStatus: {
    0: 'Created',
    1: 'In Progress',
    2: 'Approved',
    3: 'Rejected',
    4: 'Disabled'
  },
  supportPaymentStatus: {
    0: 'Failed',
    1: 'Paid',
    2: 'In Progress'
  },
  somethingWentWrongErrorMessage: 'Something went wrong, please try again later !',
  numberExactly15DigitsErrorMessage: 'Number must be exactly 15 digits',
  enterValidAllocatedNumberErrorMessage: 'Please enter a valid Allocated number of 15 digits',
  supportAddedSuccessMessage: 'Support added successfully',
  invoiceText: 'Invoice',
  totalCompaniesText: 'Total Companies',
  customerCompaniesText: 'Custom Companies',
  othersCompaniesText: 'Other Companies',
  searchPlaceholder: 'Search',
  dateRangeBtnText: 'Date range',
  addCompanyBtnText: 'Add Company',
  infoText: 'Info',
  notAbleToMakeChangesErrorMessage: 'You can not make any changes into Instant Support custom plan',
  planPurchasedSection: {
    title: 'Plan Purchased',
    planNameLabel: 'Plan Name',
    customText: 'Custom',
    billingTypeLabel: 'Billing Type',
    yearlyText: 'Yearly',
    monthlyText: 'Monthly',
    expiredDateLabel: 'Expiry Date',
    totalLabel: 'Total'
  },
  seatsSection: {
    title: 'Seats',
    seatPurchasedLabel: 'Seats Purchased',
    seatsUsedLabel: 'Seats Used',
    perSeatsPriceLabel: 'Per Seat Price'
  },
  supportNumberSection: {
    title: 'Support Number',
    numberLabel: 'Number',
    addSupportNumberLabel: 'Add Support Number',
    addSupportNumberPlaceholder: 'Enter Allocated Number',
    confirmAllocatedNumberPlaceholder: 'Confirm Allocated Number',
    numberDoesNotMatchErrorMessage: 'Numbers do not match',
    enterValidAllocatedNumberErrorMessage: 'Please enter a valid Allocated number of 15 digits',
    numberDoNotMatchErrorMessage: 'Numbers do not match',
    doneBtnText: 'Done'
  },
  addCompanyPageData: {
    editCompanyTitle: 'Edit Company',
    addCompanyTitle: 'Add Company',
    detailsText: 'Details',
    statusText: 'Status:',
    companyDetailsTitle: 'Company Details',
    statusMapping: {
      0: 'Created',
      1: 'Approval Requested',
      2: 'Approved',
      3: 'Rejected',
      4: 'Disabled'
    },
    planIDsToPlanNames: {
      0: 'telephonic',
      1: 'face',
      2: 'rise'
    },
    failedToFetchDetailsErrorMessage: 'Failed to fetch company details',
    errorOccuredWhileFetchDetailsMessage: 'An error occurred while fetching company details',
    pleaseProvideReasonErrorMessage: 'Please provide a reason',
    companyUpdatedSuccessMessage: 'Company updated successfully!',
    companyAddedSuccessMessage: 'Company added successfully!',
    companyStatusUpdateSuccessMessage: 'Company status updated successfully',
    companyApprovedSuccessMessage: 'Company approved successfully',
    companyRejectedSuccessMessage: 'Company rejected successfully',
    companyDisabledSuccessMessage: 'Company disabled successfully',
    updateCompanyStatusErrorMessage: 'Failed to update company status',
    givenNumberrequriedToApprovalErrorMessage: 'Allocated number is required for approval',
    enterValidUKNumberErrorMessage: 'Please enter a valid UK mobile number',
    noChangesDetectedErrorMessage: 'No changes detected',
    selectedCompanyerrorMessage: 'Please select a compnay',
    numberOfSeatIsEmptyErrorMessage: 'Number of seat is empty',
    enterValidMobileNumberErrorMessage: 'Please enter a valid mobile number',
    updatingCompanyErrorMessage: 'An error occurred while updating the company',
    addingCompanyErrorMessage: 'An error occurred while adding the company',
    companyNameLabel: 'Company name',
    companyNamePlaceholder: 'Search or select a company',
    searchingText: 'Searching...',
    loadingMoreText: 'Loading more...',
    loadingText: 'Loading...',
    noCompanyFoundText: 'No companies found',
    supportTypeLabel: 'Support type',
    supportTypeOptions: {
      sales: 'Sales',
      payOnInvoice: 'Pay on invoice',
      stripe: 'Stripe',
      default: 'Select support type'
    },
    planPurchasedLabel: 'Plan purchased',
    planPurchasedOptions: {
      telephonicEap: 'Telephonic EAP',
      faceToFace: 'Face to Face & Video Services EAP',
      shoorahRisePlan: 'Shoorah RISE Plan',
      default: 'Select plan'
    },
    planPriceLabel: 'Plan price',
    planPricePlaceholder: 'Enter price (0-30)',
    currencySign: '£',
    datePaidLabel: 'Date paid',
    expiredDateLabel: 'Expire date',
    numberOfSeatsLabel: 'Number of seats',
    numberOfSeatsPlaceholder: 'Number of Seats',
    allocatedNumberLabel: 'Allocated number',
    allocatedNumberPlaceholder: '07123456789',
    requriedApprovalNumberValidationMessage: 'Required for approval',
    enterValidAllocatedNumberMessage: 'Please enter a valid UK mobile number (e.g., 07123456789)',
    planTypeLabel: 'Plan type',
    planTypeOptions: {
      yearly: 'Yearly',
      monthly: 'Monthly'
    },
    approveBtnText: 'Approve',
    rejectBtnText: 'reject',
    updateBtnText: 'Update',
    disableBtnText: 'Disable',
    doneBtnText: 'Done',
    addReasonText: 'Add Reason',
    pleaseProvideRejectCompanyMessage: 'Please provide a reason for rejecting this company.',
    pleaseProvideDisableCompanyMessage: 'Please provide a reason for disabling this company.',
    enterReasonPlaceHolder: 'Enter reason here...',
    characterLimitText: '*250 Character limit',
    textboxNotEmptyMessage: '* Text box cannot be empty',
    submitBtnText: 'Submit'
  },
  topBarData: {
    description:
      "Expert support, right when it's needed most. Give your team the backing they deserve, with instant access to professionals who can help today.",
    userTypeLabel: 'User Type',
    userTypeOptions: [
      { name: 'B2B', value: 2 },
      { name: 'B2C', value: 1 }
    ],
    commonTimeLabel: 'Common Time',
    commonTimeOptions: [
      { name: 'Morning', value: 'Morning' },
      { name: 'Afternoon', value: 'Afternoon' },
      { name: 'Evening', value: 'Evening' }
    ],
    selectDateCriteriaText: 'Select Date Criteria',
    allLocationsText: 'All Locations',
    allDepartment: 'All Department',
    allEmotionsText: 'All Emotions',
    personalEmotionsText: 'Personal Emotions',
    professionalEmotionsText: 'Professional Emotions',
    allAgesText: 'All Ages',
    allEthinicitiesText: 'All Ethinicities',
    allGendersText: 'All Genders',
    doneBtnText: 'Done',
    superAdminText: 'Super Admin',
    subAdminText: 'Sub Admin',
    changePasswordBtnText: 'Change Password',
    darkModeText: 'Darkmode',
    logOutText: 'Logout'
  }
};

export const InstantSupportB2CPageData = {
  metaTitle: 'Instant Support B2C | Shoorah Admin',
  underMaintananceText: 'This Page is under maintainace & development',
  goToHomeBtnText: ' Go back home'
};

export const RejectExpertPopUpData = {
  confirm: 'Confirm',
  yesText: 'Yes',
  noText: 'No',
  rejectConfirmMessage: 'Are you sure you want to decline this expert?',
  reasonLabel: 'Reason'
};

export const ShoorahTestDashboardPageData = {
  metaTitle: 'Shoorah | Shoorah Tests',
  pageTitle: 'Shoorah Test',
  tableHeaderText: {
    testTitle: 'Test Title',
    testGroup: 'Tests Group',
    createdBy: 'Created By',
    createdDate: 'Created Date',
    status: 'Status'
  },
  failedToFetchTestErrorMessage: 'Failed to fetch tests. Please try again.',
  testDeleteSuccessMessage: 'Test deleted successfully',
  testDeleteErrorMessage: 'Something went wrong while deleting the test',
  testRestoreSuccessMessage: 'Test restored successfully',
  testRestoreErrorMessage: 'Something went wrong while restoring the test',
  failedToRestoreTestMessage: 'Failed to restore test. Please try again.',
  statusOptions: {
    draft: 'Draft',
    pending: 'Pending',
    rejected: 'Rejected',
    approved: 'Approved',
    published: 'Published',
    deleted: 'Deleted',
    unknown: 'Unknown'
  },
  searchPlaceholder: 'Search',
  dateCreatedText: 'Date Created',
  addTextBtnText: 'Add Test',
  creatTestPageData: {
    metaTitle: 'Shoorah | Shoorah Tests',
    pageTitle: 'Shoorah Test',
    createTestTitle: 'Create Test',
    previewTestTitle: 'Preview Test',
    previewBtnText: 'Preview',
    editBtnText: 'Edit',
    testImageLabel: 'Test Image',
    imagePlaceholder: {
      dropTheBrand: 'Drop the brand',
      image: 'image',
      here: 'here',
      selectedText: 'Selected:',
      imageFileType: 'KB'
    },
    testTitleLabel: 'Test Title',
    testTitlePlaceholder: 'Enter title: e.g Social Anxiety Test',
    testTitleMaxCharacterMessage: 'Title cannot exceed 100 characters',
    testTitleMaxCharacter: '/100 characters',
    testCategoryLabel: 'Test Category',
    selectCategoryLabel: 'Select categories',
    noCategoryMessage: 'No categories available',
    testDescriptionLabel: 'Test Description',
    testDescriptionPlaceholder:
      'Enter description: e.g Take this assessment to find out if you may have symptoms of social anxiety.',
    testDescriptionMaxCharacter: '/2000 characters',
    whoIsThisForLabel: 'Who is this for?',
    whoIsThisForPlaceholder: 'Enter some copy covering what this assessment is about:',
    isItAccurateLabel: 'Is it accurate?',
    researchEvidenceLabel: 'Research and scientific evidence',
    expertInformationLabel: 'Experts Information',
    createdByLabel: 'Created By',
    selectProfessionalLabel: 'Select professional',
    searchProfessionalPlaceholder: 'Search professionals',
    LoadingProfessionalText: 'Loading more professionals...',
    noProfessionalFoundMessage: 'No professionals found',
    reviewedByLabel: 'Reviewed By',
    approvedByLabel: 'Approved By',
    textTypeLabel: 'Test Type',
    textTypePlaceholder: 'Select a Test Type',
    textForLabel: 'Test For',
    textForPlaceHolder: 'Select Audience',
    testTimeLabel: 'Test Time (minutes)',
    optionalLabel: '(optional)',
    testTimePlaceholder: 'e.g., 2, 5, 10',
    timeBetween1to180ErrorMessage: 'Test time must be between 1 and 180 minutes',
    minutesLabel: 'Minutes (1-180)',
    questionSign: 'Q',
    duplicateBtnText: 'Duplicate',
    deleteBtnText: 'Delete',
    addQuestionHereLabel: 'Add Question here',
    enterYourQuestionLabel: 'Enter your question',
    weightPlaceholder: 'Weight',
    valuePalaceholder: 'Value',
    answerChoiceLabel: 'Answer Choice',
    answerChoicePlaceholder: 'Enter answer choices',
    weightErrorMessageBeforeValue: 'Weight must be between ',
    weightErrorMessageAfterValue: ' and ',
    saveQuestionBtnText: 'Save Question',
    resultCalculationLabel: 'Result Calculation',
    minScoreLabel: 'Min. Score',
    minScorePlaceholder: '0',
    maxScoreLabel: 'Max. Score',
    maxScorePlaceholder: '25',
    labelText: 'Label',
    labelPlaceholder: 'Enter label for this range',
    saveScoreRangeBtnText: 'Save Score Range',
    resultsLabel: 'Results',
    submitBtnText: 'Submit',
    saveAsDraftBtnText: 'Save as draft',
    approveBtnText: 'Approve',
    rejectBtnText: 'Reject',
    noCategorySelectedMessage: 'No category selected',
    testTypeOptions: [
      { value: '1', label: 'Percentage Based' },
      { value: '2', label: 'Attachment Style' }
    ],
    audienceOptions: [
      { value: '2', label: 'Children' },
      { value: '1', label: 'Adults' },
      { value: '3', label: 'Both' }
    ],
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    fileShouldBeLessThan1MB: 'File size should be less than 1MB',
    markedDates: [new Date('2024-05-05'), new Date('2024-05-10'), new Date('2024-05-15')],
    scoreRangeErrorMessage: 'Please fill all fields for the score range',
    maximumScoreGreaterThenMinimumScoreMessage: 'Maximum score must be greater than minimum score',
    scorerangeCanNotOverlapMessage: 'Score ranges cannot overlap',
    scoreRangeAddedSuccessMessage: 'Score range added successfully',
    weightMustBeBetween0And10Message: 'Weight must be between 0 and 10.',
    questionTestIsRequriedMessage: 'Question text is required',
    optionTestIsRequriedMessage: 'Option text is required',
    optionValueIsRequriedMessage: 'Option value is required',
    questionSaveSuccessMessage: 'Question saved successfully!',
    questionExistsCanNotChageTypeMessage: `Questions exist can't change Type`,
    testTypeChangeToSuccessMessage: 'Test type changed to',
    somethingWentWrongInFetchCategortMessage:
      'Something went wrong in getting Test catagories, please try again later !',
    testApproveSuccessMessage: 'Test Approved Successfully',
    testRejectSuccessMessage: 'Test Rejected Successfully',
    testNotApproveErrorMessage: 'Test could not be Approved',
    testCreatedSuccessMessage: 'Test Created Successfully',
    testUpdateSuccessMessage: 'Test Updated Successfully',
    failedToGetTestDataErrorMessage: 'Failed to get test information',
    errorWhileFetchTestDataMessage: 'An error occurred while fetching Test information',
    requriedMessage: 'required'
  }
};

export const ShoorahTestB2CUsersPageData = {
  metaTitle: 'Shoorah Test | Shoorah Admin',
  pageTitle: 'Shoorah Test',
  searchPlaceholder: 'Search',
  tableHeaderText: {
    name: 'Name',
    selfTakenTest: 'Self-taken tests',
    otherUsersTest: 'Other user tests',
    reTakenTest: 'Retaken Tests'
  },
  unAuthorizedErrorMessage: 'Unauthorized',
  noDataFoundErrorMessage: 'No data found',
  failedToFetchDataErrorMessage: 'Failed to fetch data. Please try again.',
  emptyReceivedFileErrorMessage: 'Received empty PDF file',
  downloadReportSuccessMessage: `Report downloaded successfully`,
  noDataReceivedErrorMessage: 'No data received from server',
  failedToDownloadReportErrormessage: 'Failed to download report. Please try again later.',
  nullText: 'N/A',
  totalNumberOfTestTitle: 'Total number of tests',
  completedTestTitle: 'Completed Tests',
  topPerformingTestTitle: 'Top Performing Test',
  dateCreatedBtnText: 'Date Created',
  testInfoLabel: 'Test Info',
  testInfoDescription: `Click on the arrow next to a user's "Retaken Tests" to view their test details`,
  noTestAvailableMesage: 'No tests available for this user',
  testHistoryLabel: 'Test History',
  testsLabel: 'tests',
  dateAndTimeLabel: 'Date & Time',
  noDataAvailableMessage: 'No date available',
  unknownTestLabel: 'Unknown Test',
  viewResultsBtnTest: 'View Results',
  scoreLabel: 'Score:',
  resultLabel: 'Result:',
  topBarData: {
    description:
      "Expert support, right when it's needed most. Give your team the backing they deserve, with instant access to professionals who can help today.",
    userTypeLabel: 'User Type',
    userTypeOptions: [
      { name: 'B2B', value: 2 },
      { name: 'B2C', value: 1 }
    ],
    commonTimeLabel: 'Common Time',
    commonTimeOptions: [
      { name: 'Morning', value: 'Morning' },
      { name: 'Afternoon', value: 'Afternoon' },
      { name: 'Evening', value: 'Evening' }
    ],
    selectDateCriteriaText: 'Select Date Criteria',
    allLocationsText: 'All Locations',
    allDepartment: 'All Department',
    allEmotionsText: 'All Emotions',
    personalEmotionsText: 'Personal Emotions',
    professionalEmotionsText: 'Professional Emotions',
    allAgesText: 'All Ages',
    allEthinicitiesText: 'All Ethinicities',
    allGendersText: 'All Genders',
    doneBtnText: 'Done',
    superAdminText: 'Super Admin',
    subAdminText: 'Sub Admin',
    changePasswordBtnText: 'Change Password',
    darkModeText: 'Darkmode',
    logOutText: 'Logout'
  }
};

export const ShoorahTestB2BUsersPageData = {
  metaTitle: 'Shoorah Test | Shoorah Admin',
  pageTitle: 'B2B Companies',
  tableHeaderText: {
    company: 'Company',
    selfTakenTest: 'Self Taken Tests',
    otherTaken: 'Others Taken',
    reTakenTest: 'Retaken Tests'
  },
  somethingWentWrongErrorMessage: 'Something went wrong, please try again later !',
  activetext: 'Active',
  inActiveText: 'Inactive',
  totalCompaniesTitle: 'Total Companies',
  totalEmployeesTitle: 'Total Employees',
  selfTakenTestTitle: 'Self Taken Tests',
  searchPlaceholder: 'Search',
  comapanyTestResultPageData: {
    metaTitle: 'Company Test Results | Shoorah Admin',
    pageTitle: 'Shoorah Test',
    searchPlaceholder: 'Search users',
    tableHeaderText: {
      name: 'Name',
      selfTakenTest: 'Self-taken tests',
      otherUserTest: 'Other user tests',
      reTakenTest: 'Retaken Tests'
    },
    companyIDNotFoundErrorMessage: 'Company ID not found',
    somethingWentWrongErrorMessage: 'Something went wrong, please try again later !',
    unAuthorizedErrorMessage: 'Unauthorized',
    noDataFoundErrorMessage: 'No data found',
    failedToFetchDataErrorMessage: 'Failed to fetch data. Please try again.',
    emptyReceivedFileErrorMessage: 'Received empty PDF file',
    downloadReportSuccessMessage: `Report downloaded successfully`,
    noDataReceivedErrorMessage: 'No data received from server',
    failedToDownloadReportErrormessage: 'Failed to download report. Please try again later.',
    nullText: 'N/A',
    totalNumberOfTestTitle: 'Total number of tests',
    completedTestTitle: 'Completed Tests',
    topPerformingTestTitle: 'Top Performing Test',
    dateCreatedBtnText: 'Date Created',
    testInfoLabel: 'Test Info',
    testInfoDescription: `Click on the arrow next to a user's "Retaken Tests" to view their test details`,
    noTestAvailableMesage: 'No tests available for this user',
    testHistoryLabel: 'Test History',
    testsLabel: 'tests',
    dateAndTimeLabel: 'Date & Time',
    noDataAvailableMessage: 'No date available',
    unknownTestLabel: 'Unknown Test',
    viewResultsBtnTest: 'View Results',
    scoreLabel: 'Score:',
    resultLabel: 'Result:'
  }
};

export const PushNotificationPageData = {
  metaTitle: 'Push Notifications | Shoorah Admin',
  pageTitle: 'Push Notifications',
  tableHeaderText: {
    title: 'Title',
    listenAudio: 'Listen Audio',
    sentBy: 'Sent By',
    message: 'Message',
    sentToUsers: 'Sent to users',
    publishOn: 'Published On',
    views: 'Views'
  },
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by title',
  addNewBtnText: 'Add New',
  addPushNotificationPageData: {
    notificationTitle: 'Notification',
    addNotificationTitle: 'Add Notification',
    shoorahB2BmetaTitle: 'Add Notifications | Shoorah B2B',
    metaTitle: 'Add Push Notifications | Shoorah Admin',
    listingPageTitle: 'Push Notification',
    pageTitle: 'Add Push Notifications',
    uploadAudioFileErrorMessageBeforeName: 'The specified file ',
    uploadAudioFileErrorMessageAfterName: ' could not be uploaded. Please upload valid audio file.',
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    fileShouldBeLessThan1MB: 'File size should be less than 1MB',
    notificationAudioLabel: 'Notification Audio',
    uploadAudioLabel: 'Upload Audio ',
    uploadLabel: 'Upload',
    durationText: 'Duration',
    pushTitleLabel: 'Push Title',
    pushMessageLabel: 'Push Message',
    sendToUsersLabel: 'Sent to Users',
    sendToDepartment: 'Send to Department',
    searchEmailOrMobileLabel: 'Search email / mobile',
    pushReminderLabel: 'Push reminder',
    pushDateLabel: 'Push Date',
    cancelBtnText: 'Cancel',
    saveBtnText: 'Save',
    validationMessages: {
      enterTitleErrorMessage: 'Please enter the title.',
      enterMessageErrorMessage: 'Please enter the message.',
      selectEmailErrorMessage: 'Please select email address.',
      selectAtLeastOneUserErrorMessage: 'Please select atleast one user or department.'
    }
  }
};

export const CommonInputData = {
  charactersLeftText: ' Characters Left',
  outOfCharacterLimit100: 'Out Of Character Limit 100',
  outOfCharacterLimit25: 'Out Of Character Limit 25',
  emailPlaceholder: 'Search email address',
  noDataText: 'No data',
  loadingText: 'Loading...',
  pleaseSelectText: 'Please Select'
};

export const CommonTopBarData = {
  description:
    "Expert support, right when it's needed most. Give your team the backing they deserve, with instant access to professionals who can help today.",
  userTypeLabel: 'User Type',
  userTypeOptions: [
    { name: 'B2B', value: 2 },
    { name: 'B2C', value: 1 }
  ],
  commonTimeLabel: 'Common Time',
  commonTimeOptions: [
    { name: 'Morning', value: 'Morning' },
    { name: 'Afternoon', value: 'Afternoon' },
    { name: 'Evening', value: 'Evening' }
  ],
  selectDateCriteriaText: 'Select Date Criteria',
  allLocationsText: 'All Locations',
  allDepartment: 'All Department',
  allEmotionsText: 'All Emotions',
  personalEmotionsText: 'Personal Emotions',
  professionalEmotionsText: 'Professional Emotions',
  allAgesText: 'All Ages',
  allEthinicitiesText: 'All Ethinicities',
  allGendersText: 'All Genders',
  doneBtnText: 'Done',
  superAdminText: 'Super Admin',
  subAdminText: 'Sub Admin',
  changePasswordBtnText: 'Change Password',
  darkModeText: 'Darkmode',
  logOutText: 'Logout'
};

export const AppIssuesPageData = {
  metaTitle: 'App Issues | Shoorah Admin',
  pageTitle: 'App Issues',
  tableHeaderText: {
    issueName: 'Issue Name',
    contentName: 'Content Name',
    sentToDev: 'Sent To Dev',
    description: 'Description',
    fixed: 'Fixed',
    implemented: 'Implemented',
    report: 'Report',
    issuedOn: 'Issued on'
  },
  issuesData: [
    'Some captions are wrong',
    'Most of the captions are wrong',
    'Captions not synced well',
    'Kids Issue'
  ],
  nullText: 'N/A',
  perPageText: 'Per Page'
};

export const AppFeedBackPageData = {
  metaTitle: 'App Feedbacks | Shoorah Admin',
  pageTitle: 'App Feedbacks',
  contentNameText: 'Content Name',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by content name',
  filtersText: 'Filters',
  resetFiltersBtnText: 'Reset Filter',
  closeBtnText: 'Close',
  contentTypeLabel: 'Content Type'
};

export const FocusPageData = {
  metaTitle: 'Focus | Shoorah Admin',
  pageTitle: 'Focus',
  adminListDefault: { name: 'Select Admin', value: '' },
  tableHeaderText: {
    focusName: 'Focus Name',
    type: 'Type',
    approvalStatus: 'Approval Status',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    status: 'Status',
    actions: 'Actions'
  },
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by focus name',
  listBtnText: 'List',
  draftsBtnText: 'Drafts',
  addNewBtnText: 'Add New',
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    focusTypeLabel: 'Focus type',
    approvalStatusLabel: 'Approval status',
    statusLabel: 'Status',
    createdByLabel: 'Created by',
    approvedByLabel: 'Approved By'
  },
  addFocusPageData: {
    focusTitle: 'Focus',
    addFocusTitle: 'Add focus',
    viewFocusTitle: 'View focus',
    editFocusTitle: 'Edit focus',
    viewFocusMetaTitle: 'View Focus | Shoorah Admin',
    editFocusMetaTitle: 'Edit Focus | Shoorah Admin',
    addFocusMetaTitle: 'Add Focus | Shoorah Admin',
    nameCanNotBeEmptyErrorMessage: 'Name can not be empty',
    focusNameLabel: 'Focus Name',
    focusTypeLabel: 'Focus type',
    statusLabel: 'Status',
    cancelBtnText: 'Cancel',
    saveDraftBtnText: 'Save Draft',
    submitBtnText: 'Submit',
    submitForApprovalBtnText: 'Submit For Approval',
    viewTitle: 'View',
    updateFocusDetailsConfirmMessage: 'Are you sure you want to update focus details?',
    approveHistorySectionData: {
      historyText: 'history',
      approvedByText: 'Approved by',
      rejectedByText: 'Rejected by',
      addedInDraftByText: 'Added in draft by'
    },
    enterFocusNameErrorMessage: 'Please enter focus name.'
  }
};

export const businessHubB2BDashboardPageData = {
  topbarTitleSalutationText: 'Hi ',
  companyHeading: 'Company Dashboard',
  overallCompanyGraphTitle: 'Overall Company Graph',
  selectYearOptionLabel: 'Select Year',
  selectCompanyOptionLabel: 'Select Company',
  selectCategoryOptionLabel: 'Select Category'
};

export const businessHubB2BEarningsPageData = {
  topbarTitleText: 'Earnings',
  companyHeading: 'Earnings',
  revenueSectionTitle: 'Revenue Details',
  selectCompanyOptionLabel: 'All Company',
  revenueDetailsDefaultData: [
    { name: 'Users', status: '12K' },
    { name: 'Revenue', status: '$85k' },
    {
      name: 'Conversation Rate',
      status: '3.33%'
    },
    { name: 'Sessions', status: '15K' }
  ],
  revenueDetailsDataOne: {
    name: 'Users',
    status: ''
  },
  revenueDetailsDataTwo: {
    name: 'Annual Revenue',
    status: '£ '
  },
  revenueDetailsDataThree: {
    name: 'Six Month Revenue',
    status: '£ '
  },
  revenueDetailsDataFour: {
    name: 'Monthly Revenue',
    status: '£ '
  },
  paginationRateText: 'Per Page',
  searchPlaceholder: 'Search by user name and email or mobile number',
  tableColumns: [
    {
      title: 'Transaction ID',
      key: 'transactionId',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 130
    },
    {
      title: 'Company Name',
      key: 'companyName',
      type: 'text',
      align: 'left'
    },
    {
      title: 'Email',
      key: 'companyEmail',
      type: 'text',
      align: 'left'
    },
    {
      title: 'Start Date',
      key: 'contractStartDate',
      sortable: false,
      type: 'date',
      align: 'left'
    },
    {
      title: 'End Date',
      key: 'contractEndDate',
      sortable: false,
      type: 'date',
      align: 'left'
    },
    {
      title: 'Subscription Type',
      key: 'companySubscription',
      sortable: false,
      type: 'customTemplate',
      customTemplateRender: (row) => (
        <div>
          {row?.isCharity
            ? 'Charity'
            : row?.companySubscription
              ? ACCOUNT_TYPE?.find((type) => type.value === row?.companySubscription)?.name
              : '-'}
        </div>
      ),
      align: 'left',
      width: 148
    },
    {
      title: 'Contract Length (Months)',
      key: 'contractLength',
      sortable: false,
      type: 'customTemplate',
      customTemplateRender: (row) => <ContractLengthComponent row={row} />,
      align: 'center'
    },
    // {
    //   title: "Plan",
    //   key: "plan",
    //   sortable: false,
    //   type: "text",
    //   align: "left",
    // },
    {
      title: 'Subscription Status',
      key: 'restrictCompany',
      sortable: false,
      type: 'company-toggle',
      align: 'center',
      width: 148
    }
  ]
};

export const businessHubB2BCompanyListPageData = {
  metaTitle: 'B2B | Dashboard',
  topbarTitleText: 'Company List',
  paginationRateText: 'Per Page',
  searchPlaceholder: 'Search by company name and email',
  addCompanyText: 'Add Company +',
  filtersModal: {
    title: 'Filters',
    resetButtonText: 'Reset Filter',
    closeButtonText: 'Close',
    selectMenuOne: {
      label: 'Subscription Status'
    },
    selectMenuTwo: {
      label: 'Contract Status',
      menuList: [
        { name: 'All', value: '' },
        { name: 'Contract Signed', value: true },
        { name: 'Contract Pending', value: false }
      ]
    }
  },
  tableColumns: [
    {
      title: 'Profile',
      key: 'profile',
      sortable: false,
      type: 'profile',
      align: 'left',
      width: 350, // Increased width for company name and email
      style: {
        opacity: 'opacity-100'
      }
    },
    {
      title: 'Contract End Date',
      key: 'contract_end_date',
      type: 'date',
      sortable: true,
      align: 'left',
      width: 150
    },
    {
      title: 'Cost Per Seat',
      key: 'seat_price',
      type: 'number',
      align: 'center',
      width: 120
    },
    {
      title: 'Subscription',
      key: 'company_subscription',
      sortable: false,
      sortKey: 'company_subscription',
      type: 'accountType',
      align: 'left',
      width: 130
    },
    {
      title: 'Contract Signed',
      key: 'contract_signed',
      sortable: false,
      type: 'boolean',
      align: 'center',
      width: 130
    },
    {
      title: 'Action',
      key: 'action',
      type: 'action',
      align: 'right',
      isView: '/B2B-company-list/viewCompany',
      isEdit: '/B2B-company-list/addCompany',
      isDelete: false,
      width: 100
    }
  ]
};

export const CompanyCountPageData = {
  DownloadText: 'Download Report',
  B2bInterestDetailDataNameOne: 'Total',
  B2bInterestDetailDataNameTwo: 'Website',
  B2bInterestDetailDataNameThree: 'Sales Team',
  B2bInterestDetailDataNameFour: 'Paid Advertisement',
  B2bInterestDetailDataNameFive: 'Google',
  B2bInterestDetailDataNameSix: 'Facebook',
  B2bInterestDetailDataNameSeven: 'LinkedIn',
  CompanyCountCardOneData: {
    name: 'All Companies',
    labelOne: 'Active',
    labelTwo: 'Inactive'
  },
  CompanyCountCardTwoData: {
    name: 'Companies in negotiation',
    labelOne: 'Active',
    labelTwo: 'Inactive'
  },
  CompanyCountCardThreeData: {
    name: 'Company signed',
    labelOne: 'Active',
    labelTwo: 'Inactive'
  },
  CompanyCountCardFourData: {
    name: 'B2B users',
    labelOne: 'Active',
    labelTwo: 'Inactive'
  },
  CompanyCountCardFiveData: {
    name: 'Seat for all companies',
    labelOne: 'Active',
    labelTwo: 'Inactive'
  },
  CompanyCountSecondGraphMessage: 'Monthly new client Vs last months',
  CompanyComparisonGraphResultTextOne: 'New Client: ',
  CompanyComparisonGraphResultTextTwo: 'Last Client: ',
  AdminMoodDetailsTitle: 'B2B Admin Mood Details',
  B2bMoodDetailDataNameOne: 'Happy',
  B2bMoodDetailDataNameTwo: 'Sad',
  B2bMoodDetailDataNameThree: 'Angry',
  B2bMoodDetailDataNameFour: 'Neutral',
  InterestDetailsTitle: 'B2B Interest Details'
};

export const AddCompanyPageData = {
  metaTitle: 'Users | Shoorah Admin',
  topbarTitleText: 'Add Company',
  fileInputTitle: 'upload photos',
  companyData: {
    title: 'Company Info',
    formEntryOne: {
      label: 'Company Name',
      placeholder: 'Enter Name'
    },
    formEntryTwo: {
      label: 'Company Address',
      placeholder: 'Enter Address'
    },
    formEntryThree: {
      label: 'Company Email',
      placeholder: 'Enter Email'
    },
    formEntryFour: {
      label: 'Contact Person',
      placeholder: 'Enter Person Name'
    },
    formEntryFive: {
      label: 'Contact Number',
      placeholder: 'Enter phone number'
    },
    formEntrySix: {
      label: 'Select Company Type',
      placeholder: 'Select the companyType'
    },
    formEntrySeven: {
      label: 'Other Admin Emails',
      supportLabel: "'(Seperated by ,)'",
      placeholder: 'Enter Emails'
    }
  },
  seatsData: {
    title: 'Seats Details',
    formEntryOne: {
      label: 'Number of Seats Bought',
      placeholder: 'Enter no of seat bought'
    },
    formEntryTwo: {
      label: 'B2B Plan',
      placeholder: 'Select'
    },
    formEntryThree: {
      label: 'Payment Plan',
      nullValueText: 'Select Plan',
      monthlySubscriptionValueText: 'Monthly Subscription',
      semiAnnualSubscriptionValueText: 'Semi Annual Subscription',
      annualSubscriptionValueText: 'Annual Subscription',
      oneTimeSubscriptionValueText: 'One Time Subscription'
    },
    formEntryFour: {
      label: 'Per Seat Price',
      placeholder: 'Enter seat price (e.g. 1.50, 2.25)'
    },
    formEntryFive: {
      label: 'Vat Tax Apply ( 20 %)',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntrySix: {
      label: 'Discount',
      placeholder: 'Enter no of seat bought'
    },
    formEntrySeven: {
      label: 'Total Amount',
      supportValue: '% discounted'
    },
    formEntryEight: {
      label: 'Total Contract Amount',
      supportValue: '% discounted'
    },
    formEntryNine: {
      label: 'Only Update Subscription Details',
      title:
        'By enabling this, subscription details will only update details. so that it will not affect current plan subscription or trial.'
    }
  },
  contractData: {
    title: 'Contract Details',
    formEntryOne: {
      label: 'Contract Start Date',
      placeholder: 'Contract Start Date'
    },
    formEntryTwo: {
      label: 'Contract End Date',
      placeholder: 'Contract End Date'
    },
    formEntryThree: {
      label: 'Contract Length',
      nullValueText: 'NA'
    },
    formEntryFour: {
      label: 'Contract Progress',
      trueValueText: 'Signed',
      falseValueText: 'Under Negotiation'
    },
    formEntryFive: {
      label: 'B2B Interest Via',
      nullValueText: 'Select',
      websiteValueText: 'Website',
      salesTeamValueText: 'Sales Team',
      paidAdValueText: 'Paid Advertisement',
      googleValueText: 'Google',
      fbValueText: 'Facebook',
      linkedInValueText: 'Linkedin'
    },
    formEntrySix: {
      label: 'Terms Agreed',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntrySeven: {
      label: 'Salesman',
      placeholder: 'Enter the salesman name'
    },
    formEntryEight: {
      label: 'Contract Sent',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntryNine: {
      label: 'Contract Signed',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntryTen: {
      label: 'Invoice Raised',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntryEleven: {
      label: 'Payment Complete',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntryTwelve: {
      label: 'Seats Active Live',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    switchDataOne: {
      label: 'Restrict Company',
      supportText:
        'When made inactive will restrict all assigned users red message to speak to company admin for assistance.'
    },
    switchDataTwo: {
      label: 'Shuru Usage',
      supportText:
        'When made inactive will restrict all assigned users of this company unable to use shuru.'
    },
    switchDataThree: {
      label: 'Peap Usage',
      supportText:
        'When made inactive will restrict all assigned users of this company unable to use peap.'
    },
    switchDataFour: {
      label: 'Auto Renew',
      supportText: 'When made inactive will not send auto update of contract dates and payment.'
    }
  },
  charityData: {
    title: 'Charity/Trial Options (optional)',
    formEntryOne: {
      label: 'Select number of days',
      placeholder: 'Select days'
    },
    switchDataOne: {
      label: 'Charity Toggle',
      supportText:
        'When made active this contract will be on charity account type for specified contract length.'
    },
    switchDataTwo: {
      label: 'Trial Toggle',
      supportText: 'When made active add number of days to make them use dashboard for trial days.'
    }
  },
  saveBtnText: 'Save'
};

export const ViewCompanyPageData = {
  metaTitle: 'B2B | Dashboard',
  topbarTitleText: 'Company Details',
  tabItemOne: {
    title: 'Company Profile',
    editBtnText: 'Edit Company',
    companyData: {
      title: 'Company Info',
      partnerSupportText: 'introduced by ',
      formEntryOne: {
        label: 'Company Name',
        placeholder: 'Enter Name'
      },
      formEntryTwo: {
        label: 'Company Address',
        placeholder: 'Enter Address'
      },
      formEntryThree: {
        label: 'Company Email',
        placeholder: 'Enter Email'
      },
      formEntryFour: {
        label: 'Contact Person',
        placeholder: 'Enter Person Name'
      },
      formEntryFive: {
        label: 'Contact Number',
        placeholder: 'Enter phone number'
      },
      formEntrySix: {
        label: 'Select Company Type',
        placeholder: 'Select the companyType'
      }
    },
    seatsData: {
      title: 'Seats Details',
      formEntryOne: {
        label: 'No of Seats Bought'
      },
      formEntryTwo: {
        label: 'Currency'
      },
      formEntryThree: {
        label: 'Per Seat Price'
      },
      formEntryFour: {
        label: 'Seat Activity',
        activeText: ' Active',
        inactiveText: ' Inactive'
      }
    },
    contractData: {
      title: 'Contract Details',
      formEntryOne: {
        label: 'Contract Start Date'
      },
      formEntryTwo: {
        label: 'Contract End Date'
      },
      formEntryThree: {
        label: 'Contract Length',
        supportText: 'Month'
      },
      formEntryFour: {
        label: 'Contract Progress',
        trueValueText: 'Signed',
        falseValueText: 'Under Negotiation'
      },
      formEntryFive: {
        label: 'B2B Interest Via'
      },
      formEntrySix: {
        label: 'Terms Agreed',
        trueValueText: 'Yes',
        falseValueText: 'No'
      },
      formEntrySeven: {
        label: 'Salesman'
      },
      formEntryEight: {
        label: 'Contract Sent',
        trueValueText: 'Yes',
        falseValueText: 'No'
      },
      formEntryNine: {
        label: 'Contract Signed',
        trueValueText: 'Yes',
        falseValueText: 'No'
      },
      formEntryTen: {
        label: 'Invoice Raised',
        trueValueText: 'Yes',
        falseValueText: 'No'
      },
      formEntryEleven: {
        label: 'Payment Complete',
        trueValueText: 'Yes',
        falseValueText: 'No'
      },
      formEntryTwelve: {
        label: 'Seats Active Live',
        trueValueText: 'Yes',
        falseValueText: 'No'
      },
      switchDataOne: {
        label: 'Restrict Company',
        supportText:
          'When made inactive will restrict all assigned users red message to speak to company admin for assistance.'
      },
      switchDataTwo: {
        label: 'Shuru Usage',
        supportText:
          'When made inactive will restrict all assigned users of this company unable to use shuru.'
      },
      switchDataThree: {
        label: 'Auto Renew',
        supportText: 'When made inactive will not send auto update of contract dates and payment.'
      }
    }
  },
  tabItemTwo: {
    title: 'Users',
    tableColumns: [
      {
        title: 'Name',
        key: 'profile',
        sortable: false,
        type: 'profile',
        align: 'left',
        isView: '/users/view'
      },
      {
        title: 'User Type',
        key: 'user_type',
        sortable: false,
        type: 'userType',
        align: 'left'
      },
      // {
      //   title: 'Email',
      //   key: 'email',
      //   sortable: false,
      //   type: 'text',
      //   align: 'left'
      // },
      {
        title: 'Email / Mobile Verified',
        key: 'isEmailVerified',
        type: 'verified',
        align: 'center'
      },
      {
        title: 'Last login',
        key: 'lastLogin',
        sortable: false,
        type: 'date',
        align: 'left'
      },
      {
        title: 'Signup Platform',
        key: 'loginPlatform',
        type: 'platform',
        align: 'center'
      },
      {
        title: 'Registered On',
        key: 'registeredOn',
        sortable: false,
        type: 'date',
        align: 'left'
      }
    ],
    paginationSupportText: 'Per Page',
    searchPlaceholder: 'Search by user name and email or mobile number'
  },
  tabItemThree: {
    title: 'Dashboard'
  },
  tabItemFour: {
    title: 'B2B Admins',
    metaTitle: 'B2B Admin | Shoorah Admin',
    paginationSupportText: 'Per Page',
    searchPlaceholder: 'Search by user name and email',
    filtersModal: {
      title: 'Filters',
      resetButtonText: 'Reset Filter',
      closeButtonText: 'Close',
      selectMenuOne: {
        label: 'User Type'
      },
      selectMenuTwo: {
        label: 'Account Status'
      }
    },
    tableColumns: [
      // {
      //   title: '',
      //   key: '',
      //   sortable: false,
      //   type: 'checkBox',
      //   align: 'left',
      // },
      {
        title: 'Profile',
        key: 'profile',
        sortable: false,
        type: 'profile',
        align: 'left'
      },
      {
        title: 'User Type',
        key: 'userType',
        sortable: false,
        type: 'userType',
        align: 'left'
      },
      {
        title: 'Status',
        key: 'accountStatus',
        sortable: false,
        type: 'badge',
        align: 'left'
      },
      {
        title: 'Last login',
        key: 'lastLogin',
        sortable: false,
        type: 'date',
        align: 'left'
      },
      {
        title: 'Registered On',
        key: 'createdAt',
        sortable: false,
        type: 'date',
        align: 'left'
      },
      {
        title: 'Actions',
        key: 'action',
        type: 'action',
        align: 'right',
        isReset: true,
        isDelete: false
      }
    ]
  },
  tabItemFive: {
    title: 'Member',
    tableColumns: [
      {
        title: 'Name',
        key: 'profile',
        sortable: false,
        type: 'profile',
        align: 'left'
      },
      {
        title: 'Email',
        key: 'email',
        sortable: false,
        type: 'text',
        align: 'left'
      },
      {
        title: 'Email / Mobile Verified',
        key: 'isEmailVerified',
        type: 'verified',
        align: 'center'
      },
      {
        title: 'Last login',
        key: 'lastLogin',
        sortable: false,
        type: 'date',
        align: 'left'
      },
      {
        title: 'Signup Platform',
        key: 'loginPlatform',
        type: 'platform',
        align: 'center'
      },
      {
        title: 'Registered On',
        key: 'registeredOn',
        sortable: false,
        type: 'date',
        align: 'left'
      }
    ],
    paginationSupportText: 'Per Page',
    searchPlaceholder: 'Search by user name and email or mobile number'
  }
};

export const PartnersPageData = {
  metaTitle: 'Partnership | Shoorah Admin',
  topbarTitleText: 'Partner List',
  paginationSupportText: 'Per Page',
  searchPlaceholder: 'Search by user name and email',
  addNewPartnerBtnText: 'Add New',
  filtersModal: {
    title: 'Filters',
    resetButtonText: 'Reset Filter',
    closeButtonText: 'Close',
    selectMenuOne: {
      label: 'Account Status'
    }
  },
  tableColumns: [
    // {
    //   title: '',
    //   key: '',
    //   sortable: false,
    //   type: 'checkBox',
    //   align: 'left',
    // },
    {
      title: 'Profile',
      key: 'profile',
      sortable: false,
      type: 'profile',
      align: 'left'
    },
    // {
    //   title: 'Name',
    //   key: 'name',
    //   sortable: true,
    //   align: 'left'
    // },
    // {
    //   title: 'Email',
    //   key: 'email',
    //   sortable: false,
    //   type: 'text',
    //   align: 'left'
    // },
    {
      title: 'Contact Number',
      key: 'mobile',
      sortable: false,
      type: 'text',
      align: 'left'
    },
    {
      title: 'Job Role',
      key: 'jobRole',
      sortable: false,
      type: 'text',
      align: 'left'
    },
    {
      title: 'Commission ( % )',
      key: 'commission',
      sortable: false,
      type: 'text',
      align: 'center'
    },
    {
      title: 'Status',
      key: 'accountStatus',
      sortable: false,
      type: 'toggle',
      align: 'left'
    },
    {
      title: '',
      key: 'action',
      type: 'action',
      align: 'right',
      // isEdit: redirectUrl,
      isView: '/partners/add-partner',
      isDelete: false
    }
  ]
};

export const AddPartnerPageData = {
  metaTitle: 'Partnership | Shoorah Admin',
  topbarTitleText: 'Partnership',
  formEntryOne: {
    label: 'Name'
  },
  formEntryTwo: {
    label: 'Email Address'
  },
  formEntryThree: {
    label: 'Commission'
  },
  formEntryFour: {
    label: 'Contact Number',
    placeholder: 'Enter phone number',
    errorMessage: 'Please enter a valid number'
  },
  formEntryFive: {
    label: 'Job Role',
    nullValueText: 'B2C'
  },
  switchDataOne: {
    label: 'Account Status'
  },
  actionBtn: {
    cancelBtnText: 'Cancel',
    deleteBtnText: 'Delete',
    submitBtnText: 'Submit',
    resetPasswordBtnText: 'Reset Password'
  },
  tableColumns: [
    {
      title: 'Company Name',
      key: 'name',
      sortable: false,
      type: 'text',
      // isView :viewcompony,
      align: 'left'
      //  parant:'Partners introduced',
      // parantURL:'/partner-introduced'
    },
    {
      title: 'Introduced Date',
      key: 'createdAt',
      sortable: false,
      type: 'date',
      align: 'left'
    },
    {
      title: 'Payment Date',
      key: 'paymentDate',
      sortable: false,
      type: 'date',
      align: 'left'
    },
    {
      title: 'Payment Status',
      key: 'paymentStatus',
      sortable: false,
      type: 'text',
      align: 'left'
    },
    {
      title: 'Payment Amount',
      key: 'paymentAmount',
      sortable: false,
      type: 'text',
      align: 'left'
    },
    {
      title: 'Receipt',
      key: 'action',
      type: 'action',
      align: 'right',
      isDownload: true,
      isEdit: false,
      isDelete: false
    }
  ],
  addPaymentModal: {
    title: 'Pay to Partner',
    formEntryOne: {
      label: 'Company Name',
      placeholder: 'Select Company'
    },
    formEntryTwo: {
      label: 'Description'
    },
    formEntryThree: {
      label: 'Amount'
    },
    addImgData: {
      uploadImgBlueText: 'Click to upload',
      uploadImgNormalText: 'or drag and drop',
      subText: 'Only two files PNG, JPG or JPEG'
    },
    submitBtnText: 'Submit'
  },
  paginationSupportText: 'Per Page',
  addPaymentBtnText: 'Add Payment',
  statusMsgOne: 'Success',
  statusMsgTwo: 'Pending',
  confirmPopupMsg: 'Are you sure you want to update partner details?'
};

export const PartnersIntroducedPageData = {
  metaTitle: 'Partnership | Shoorah Admin',
  topbarTitleText: 'Partnership',
  paginationSupportText: 'Per Page',
  searchPlaceholder: 'Search by company name, email, or contact person',
  addNewPartnerBtnText: 'Add Partner +',
  filtersModal: {
    title: 'Filters',
    resetButtonText: 'Reset Filter',
    closeButtonText: 'Close',
    selectMenuOne: {
      label: 'Account Status'
    },
    selectMenuTwo: {
      menuItems: [
        { name: 'All', value: '' },
        { name: 'Active Partnerships', value: 'active' },
        { name: 'Pending Partnerships', value: 'pending' },
        { name: 'Completed Partnerships', value: 'completed' }
      ],
      label: 'Partnership Status'
    }
  },
  tableColumns: [
    {
      title: 'Profile',
      key: 'profile',
      sortable: false,
      type: 'partner-profile', // New type for partner profile with company name and email
      align: 'left',
      width: 350, // Increased width for company name and email
      style: {
        opacity: 'opacity-100'
      }
    },
    {
      title: 'Mobile',
      key: 'mobile',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 150
    },
    {
      title: 'Contact Person',
      key: 'contactPerson',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 180
    },
    {
      title: 'Partner',
      key: 'partnerName',
      sortable: false,
      type: 'Partner',
      isEdit: '/partners/add-partner',
      align: 'left',
      parant: 'Partners introduced',
      parantURL: '/partner-introduced',
      width: 150
    },
    {
      title: 'Commission (%)',
      key: 'partnerCommission',
      sortable: false,
      type: 'text',
      align: 'center',
      width: 120
    },
    {
      title: 'Introduced Date',
      key: 'createdAt',
      sortable: false,
      type: 'date',
      align: 'left',
      width: 150
    },
    {
      title: '',
      key: 'action',
      type: 'action',
      align: 'right',
      isEdit: false,
      isDelete: false,
      isView: '/partners-introduce/edit-introduce', // Add view action
      width: 100
    }
  ]
};

export const PartnersIntroducedEditPageData = {
  metaTitle: 'Users | Shoorah Admin',
  topbarTitleText: 'Partnership',
  fileInputTitle: 'upload photos',
  companyData: {
    title: 'Company Info',
    formEntryOne: {
      label: 'Company Name',
      placeholder: 'Enter Name'
    },
    formEntryTwo: {
      label: 'Company Address',
      placeholder: 'Enter Address'
    },
    formEntryThree: {
      label: 'Company Email',
      placeholder: 'Enter Email'
    },
    formEntryFour: {
      label: 'Contact Person',
      placeholder: 'Enter Person Name'
    },
    formEntryFive: {
      label: 'Contact Number',
      placeholder: 'Enter phone number'
    },
    formEntrySix: {
      label: 'Select Company Type',
      placeholder: 'Select the companyType'
    },
    formEntrySeven: {
      label: 'Other Admin Emails',
      supportLabel: "'(Seperated by ,)'",
      placeholder: 'Enter Emails'
    }
  },
  seatsData: {
    title: 'Seats Details',
    formEntryOne: {
      label: 'Number of Seats Bought',
      placeholder: 'Enter no of seat bought'
    },
    formEntryTwo: {
      label: 'B2B Plan',
      placeholder: 'Select'
    },
    formEntryThree: {
      label: 'Payment Plan',
      nullValueText: 'Select Plan',
      monthlySubscriptionValueText: 'Monthly Subscription',
      semiAnnualSubscriptionValueText: 'Semi Annual Subscription',
      annualSubscriptionValueText: 'Annual Subscription',
      oneTimeSubscriptionValueText: 'One Time Subscription'
    },
    formEntryFour: {
      label: 'Per Seat Price',
      placeholder: 'Enter seat price (e.g. 1.50, 2.25)'
    },
    formEntryFive: {
      label: 'Vat Tax Apply ( 20 %)',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntrySix: {
      label: 'Discount',
      placeholder: 'Enter no of seat bought'
    },
    formEntrySeven: {
      label: 'Total Amount',
      supportValue: '% discounted'
    },
    formEntryEight: {
      label: 'Total Contract Amount',
      supportValue: '% discounted'
    },
    formEntryNine: {
      label: 'Only Update Subscription Details',
      title:
        'By enabling this, subscription details will only update details. so that it will not affect current plan subscription or trial.'
    }
  },
  contractData: {
    title: 'Contract Details',
    formEntryOne: {
      label: 'Contract Start Date',
      placeholder: 'Contract Start Date'
    },
    formEntryTwo: {
      label: 'Contract End Date',
      placeholder: 'Contract End Date'
    },
    formEntryThree: {
      label: 'Contract Length',
      nullValueText: 'NA'
    },
    formEntryFour: {
      label: 'Contract Progress',
      trueValueText: 'Signed',
      falseValueText: 'Under Negotiation'
    },
    formEntryFive: {
      label: 'B2B Interest Via',
      nullValueText: 'Select',
      websiteValueText: 'Website',
      salesTeamValueText: 'Sales Team',
      paidAdValueText: 'Paid Advertisement',
      googleValueText: 'Google',
      fbValueText: 'Facebook',
      linkedInValueText: 'Linkedin'
    },
    formEntrySix: {
      label: 'Terms Agreed',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntrySeven: {
      label: 'Salesman',
      placeholder: 'Enter the salesman name'
    },
    formEntryEight: {
      label: 'Contract Sent',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntryNine: {
      label: 'Contract Signed',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntryTen: {
      label: 'Invoice Raised',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntryEleven: {
      label: 'Payment Complete',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    formEntryTwelve: {
      label: 'Seats Active Live',
      trueValueText: 'Yes',
      falseValueText: 'No'
    },
    switchDataOne: {
      label: 'Restrict Company',
      supportText:
        'When made inactive will restrict all assigned users red message to speak to company admin for assistance.'
    },
    switchDataTwo: {
      label: 'Shuru Usage',
      supportText:
        'When made inactive will restrict all assigned users of this company unable to use shuru.'
    },
    switchDataThree: {
      label: 'Peap Usage',
      supportText:
        'When made inactive will restrict all assigned users of this company unable to use peap.'
    },
    switchDataFour: {
      label: 'Auto Renew',
      supportText: 'When made inactive will not send auto update of contract dates and payment.'
    }
  },
  charityData: {
    title: 'Trial Options (optional)',
    formEntryOne: {
      label: 'Select number of days',
      placeholder: 'Select days'
    },
    switchDataOne: {
      label: 'Trial Toggle',
      supportText: 'When made active add number of days to make them use dashboard for trial days.'
    }
  },
  saveBtnText: 'Save'
};

export const PaginationData = {
  previousData: 'Previous page',
  nextData: 'Next Page'
};

export const TutorialsPageData = {
  metaTitle: 'Tutorials',
  pageTitle: "Tutorial's",
  searchPlaceholder: 'Search by name',
  createNewTutorialBtnText: 'Create New Tutorial',
  tableHeaderText: {
    featureName: 'Feature Name',
    dateCreated: 'Date Created',
    createdBy: 'Created By',
    approvedOn: 'Approved On',
    approvedBy: 'Approved By',
    status: 'Status',
    actions: 'Actions'
  },
  liveTutorialsTitle: 'Live Tutorials',
  videoWatchCountTitle: 'Video Watch Count',
  timesTitle: 'times',
  mostPopularTitle: 'Most Popular',
  leastUsedTitle: 'Least Used',
  tutorialRemoveSuccessMessage: 'Tutorial removed successfully',
  tutorialDraftSuccessMessage: 'Tutorial draft successfully',
  status: {
    active: 'Active',
    inActive: 'Inactive',
    draft: 'Draft',
    deleted: 'Deleted',
    rejected: 'Rejected',
    sendApproval: 'Send Approval',
    published: 'Published'
  },
  viewBtnLabel: 'View',
  editBtnLabel: 'Edit',
  previewBtnLabel: 'Preview',
  draftBtnLabel: 'Draft',
  deleteBtnLabel: 'Delete',
  deleteConfirmMessage: 'Are you sure you want to delete this tutorial?',
  draftConfirmLabel: 'Are you sure you want to Draft this tutorial?',
  filterModal: {
    filterTitle: 'Filters',
    resetFilterBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    tutorialStatusLabel: 'Tutorial Status',
    sentForApprovalTitle: 'Sent for approval',
    publishedTitle: 'Published'
  },
  editTutorialPageData: {
    metaTitle: 'Tutorials',
    previewTutorialPageTitle: 'Preview Tutorial',
    editTutorialPageTitle: 'Edit Tutorial',
    newTutorialpageTitle: 'New Tutorial',
    tutorialAreaOptions: {
      mobile: 'Mobile (all users)',
      web: 'Web (all users)'
    },
    addFeatureNameErrorMessage: 'Please add feature name',
    pleaseSelectTutorialAreaErrorMessage: 'Please select tutorial area',
    uploadFailedWithStatusErrorMessage: 'Upload failed with status: ',
    tutorialPublishedSuccessMessage: 'Tutorial published successfully',
    addContentAreaErrorMessage: 'Please add content area.',
    addTutorialInfoDetailErrorMessage: 'Please add tutorial info details.',
    uploadVideoOrImageErrorMessage: 'Please upload video or image.',
    viewBtnLabel: 'View',
    editBtnLabel: 'Edit',
    previewBtnLabel: 'Preview',
    draftBtnLabel: 'Draft',
    deleteBtnLabel: 'Delete',
    tutorialAreaLabel: 'Tutorial area',
    featureNameLabel: 'Feature Name',
    featureNamePlaceholedr: 'Enter feature allocation',
    addContentAreaTitle: 'Add Content Area:',
    infoBtnText: 'Info',
    tutorialBtnText: 'Tutorial',
    assistantBtnText: 'Assistant',
    publishBtnText: 'Publish',
    removeContentAreaConfirmMessage: 'Are you sure you want to remove this content area?',
    tutorialInfoSection: {
      faqLessThan120ErrorMessage: 'FAQ question should be less than 120 characters.',
      faqLessThan1200ErrorMessage: 'FAQ question should be less than 120 characters.',
      pleaseEnterFAQQuestionMessage: 'Please enter FAQ question.',
      pleaseEnterFAQAnswerMessage: 'Please enter FAQ answer.',
      infoMainTitleLabel: 'Please enter FAQ answer.',
      infoMainTitlePlaceholder: 'Enter title here',
      infoSubTitleLabel: 'Info Sub Title',
      infoSubTitlePlaceholder: 'Enter subtitle here',
      whyLabel: 'Why?',
      whyPlaceholder: 'Why?',
      whenLabel: 'How?',
      whenPlaceholder: 'How?',
      tipsTitleLabel: 'Tips Title',
      tipsTitlePlaceholder: 'Enter tips title here',
      tipsDescriptionLabel: `Tips Description`,
      tipsDescriptionPlaceholder: `Enter tips description here...`,
      faqsTitle: 'FAQ’s',
      faqTitleLabel: 'FAQ',
      faqFormSection: {
        faqTitleLabel: 'FAQ',
        faqQuestionLabel: 'faqQuestion',
        faqQuestionPlaceholder: 'Enter new question...',
        faqAnswerLabel: 'faqAnswer',
        faqAnswerPlaceholer: 'Enter answer...',
        characterLeftText: ' Characters Left',
        outOf100Text: 'Out Of Character Limit 100'
      },
      newFAQBtnLabel: 'New FAQ',
      nextBtnText: 'Next'
    },
    tutorialDetailsSection: {
      videoResolutionShouldBeErrorMessage: 'Video resolution should be',
      somethingWentWrongErrorMessage: 'Something went wrong.',
      imageResolutionShouldBeErrorMessage: 'Image resolution should be',
      failedToLoadImageErrorMessage: 'Failed to load image. Please try again.',
      addAContentMessage: 'Add a Content...',
      contentMainTitleLabel: 'Content Main Title',
      contentMainTitlePlaceholder: 'Enter title here',
      contentDescriptionLabel: 'Content Description',
      contentDescriptionPlaceholder: 'Enter description here',
      addVideoLabel: 'Add Video',
      dropYourVideoHereText: 'Drop your video here, or',
      browseText: 'browse',
      supportVideoText: 'Supports: MP4 File',
      addImageLabel: 'Add Image',
      addImageAreaVertical: '(1080x1920)',
      addImageAreaLandscape: '(1920x1080)',
      supportImageText: 'Supports: PNG, JPEG, JPG File',
      nextBtnText: 'Next'
    },
    tutorialAssistantSection: {
      options: {
        on: 'On',
        off: 'Off'
      },
      addAssistantTitle: 'Add Assistant?',
      onOrOffLabel: 'On or Off',
      saveAndPreviewBtnText: 'Save & Preview'
    },
    validationMessages: {
      enterMainTitleErrorMessage: 'Please enter main title.',
      titleLessThan120CharErrorMessage: 'Title should be less than 120 characters',
      mainTitleLessThan120CharErrorMessage: 'Main title should be less than 120 characters.',
      enterDescriptionErrorMessage: 'Please enter description.',
      descriptionLessThan1200CharErrorMessage: 'Description should be less than 1200 characters',
      uploadVideoOrImageErrorMessage: 'Please upload video or images.',
      enterSubTitleErrorMessage: 'Please enter sub title.',
      subTitleLessThan120CharErrorMessage: 'Sub title should be less than 120 characters.',
      enterWhyErrorMessage: 'Please enter why.',
      whyLessThan1200CharErrorMessage: 'Why should be less than 1200 characters.',
      enterWhenErrorMessage: 'Please enter when.',
      whenLessThan1200CharErrorMessage: 'When should be less than 1200 characters.',
      enterTipsTitleErrorMessage: 'Please enter tips title.',
      tipsTitleLessThan120CharErrorMessage: 'Tips title should be less than 120 characters.',
      enterTipsDescriptionErrorMessage: 'Please enter tips description.',
      tipsDescriptionLessThan1200CharErrorMessage:
        'Tips description should be less than 1200 characters.',
      addFaqQuestionsErrorMessage: 'Please add FAQ Questions.',
      enterFaqQuestionErrorMessage: 'Please enter FAQ question.',
      faqQuestionLessThan120CharErrorMessage: 'FAQ question should be less than 120 characters.',
      enterFaqAnswerErrorMessage: 'Please enter FAQ answer.',
      faqAnswerLessThan1200CharErrorMessage: 'FAQ answer should be less than 1200 characters.'
    },
    tutorialApprovalModal: {
      tutorialSentForApprovalSuccessMessage: 'Tutorial sent for approval successfully',
      approvedByIsRequriedErrorMessage: '*Approval by is required',
      unableToPublishTutorialErrorMessage: "You're currently unable to publish this tutorial",
      sendTutorialForAdminApprovalMessage: 'Send the Tutorial to an admin to approval',
      selectAdminPlaceholder: 'Select Admin...',
      sendForApprovalBtnText: 'Send for approval'
    },
    tutorialContentAreaPopUpModal: {
      textboxCanNotBeEmptyMessage: '*Text box cannot be empty',
      contentAreaAlreadyExistsMessage: 'Content area already exists',
      maximum25CharAllowedMessage: 'Maximum 25 characters allowed',
      popUpTitle: 'Add Content Area',
      contentAreaPlaceholder: 'Enter content area here...',
      submitBtnText: 'Submit'
    }
  }
};

export const AffirmationPageData = {
  metaTitle: 'Affirmation',
  pageTitle: 'Affirmation',
  tableHeaderText: {
    affirmationName: 'Affirmation Name',
    focus: 'Focus',
    approvalStatus: 'Approval Status',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    status: 'Status',
    searchPlaceholder: 'Search by affirmation name'
  },
  listBtnText: 'List',
  draftBtnText: 'Drafts',
  addNewBtnText: 'Add New',
  searchPlaceholder: 'Search by affirmation name',
  perPageText: 'Per Page',
  adminList: { name: 'Select Admin', value: '' },
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    accountStatusLabel: 'Account status',
    approvalStatusLabel: 'Approval status',
    createdByLabel: 'Created by',
    approvedByLabel: 'Approved By'
  },
  addEditAffirmationPageData: {
    mainPageTitle: 'Affirmation',
    addAffirmationTitle: 'Add Affirmation',
    viewAffirmationTitle: 'Edit Affirmation',
    EditAffrimationTitle: 'View Affirmation',
    addAffirmationMetaTitle: 'Add Affirmation | Shoorah Admin',
    editAffrimationMetaTitle: 'Edit Affirmation | Shoorah Admin',
    viewAffrimationMetaTitle: 'View Affirmation | Shoorah Admin',
    nameOrCsvFileRequriedErrorMessage: 'Name or Csv file is required',
    selectCsvFileLabel: 'Select CSV file',
    downloadSampleFileBtnText: 'Download sample file',
    selectCategoriesLabel: 'Select Categories',
    affirmationNameLabel: 'Affirmations Name',
    descriptionLabel: 'Description',
    statusLabel: 'Status',
    cancelBtnText: 'Cancel',
    saveDraftBtnText: 'Save Draft',
    submitForApprovalBtnText: 'Submit For Approval',
    submitBtnText: 'Submit',
    viewTitle: 'View',
    updateAffirmationConfirmMessage: 'Are you sure you want to update affirmation details?',
    validationMessages: {
      enterAffirmationNameErrorMessage: 'Please enter affirmation name.',
      selectAffrimationFocusErrorMessage: 'Please select affirmation focus.',
      selectCsvFileErrorMesssage: 'Please select csv file.'
    }
  }
};

export const customSelectData = {
  focusLabel: 'Focus',
  selectPlaceholder: 'Select...',
  hereLabel: ' here',
  noResultsFoundText: 'No results found',
  searchPlaceholder: 'Search...'
};

export const MeditationsPageData = {
  metaTitle: 'Meditations | Shoorah Admin',
  pageTitle: 'Meditations',
  adminList: { name: 'Select Admin', value: '' },
  perPageText: 'Per Page',
  tableHeaderText: {
    listenAudio: 'Listen Audio',
    meditationName: 'Meditation Name',
    durationName: 'Duration',
    approvalStatus: 'Approval Status',
    expertName: 'Expert Name',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    playedMinutes: 'Played Minutes',
    mostlyPlayed: 'Mostly Played',
    status: 'Status'
  },
  searchPlaceholder: 'Search',
  listBtnText: 'List',
  draftBtnText: 'Drafts',
  addNewBtnText: 'Add New',
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    statusLabel: 'Status',
    approvalStatusLabel: 'Approval status',
    createdByLabel: 'Created by',
    approvedByLabel: 'Approved By'
  },
  editMeditationPageData: {
    mainPageTitle: 'Meditation',
    addMeditationPageTitle: 'Add Meditation',
    viewMeditationPageTitle: 'View Meditation',
    editMeditationPageTitle: 'Edit Meditation',
    addMeditationMetaTitle: 'Add Meditation | Shoorah Admin',
    viewMeditationMetaTitle: 'View Meditation | Shoorah Admin',
    editMeditationMetaTitle: 'Edit Meditation | Shoorah Admin',
    meditationNameRequriedErrorMessage: 'Meditation name is required.',
    meditationDraftSuccessMessage: 'Meditation Draft Successfully',
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    fileShouldBeLessThan1MB: 'File size should be less than 1MB',
    uploadAudioFileErrorMessageBeforeName: 'The specified file ',
    uploadAudioFileErrorMessageAfterName:
      ' could not be uploaded. Please upload a valid audio file.',
    uploadSrtFileErrorMessageBeforeName: 'The specified file ',
    uploadSrtFileErrorMessageAfterName:
      ' could not be uploaded. Please upload valid caption srt file.',
    captionFileUpdatedSuccessMessage: 'Caption file updated successfully.',
    captionFileNotUpdatedErrorMessage: 'Caption file not updated.',
    meditationNameLabel: 'Meditation Name',
    meditationNamePlaceholder: 'Enter Meditation Name',
    meditationImageText: 'Meditation Image',
    meditationImageSize: '(Upload 512px * 512px image) (Max image size 1MB)',
    dropYourImageText: 'Drop your image here, or',
    browseText: 'browse',
    imageSupprotFileType: 'Supports: JPG, JPEG, PNG, GIF File',
    selectExpertLabel: 'Select Expert',
    selectCategoriesLabel: 'Select Categories',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter Description',
    statusLabel: 'Status',
    addAudioBtnText: 'Add Audio',
    audioLanguageLabel: 'Audio Language',
    meditationAudioLabel: 'Meditation Audio',
    uploadAudioLabel: 'Upload Audio',
    uploadBtnText: 'Upload',
    durationLabel: 'Duration',
    downloadCaptionFileLabel: 'Download Caption file',
    updateCaptionFileLabel: 'Update Caption file',
    cancelBtnText: 'Cancel',
    saveDraftBtnText: 'Save Draft',
    submitForApprovalBtnText: 'Submit For Approval',
    submitBtnText: 'Submit',
    viewTitle: 'View',
    updateMeditationDetailsConfirmMessage: 'Are you sure you want to update meditation details?',
    validationMessages: {
      enterNameErrorMessage: 'Please enter the name.',
      enterDescriptionErrorMessage: 'Please enter the description.',
      selectCategoryErrorMessage: 'Please select the category.',
      selectAudioErrorMessage: 'Please select the audio.',
      selectFileErrorMessage: 'Please select the file.',
      selectLanguageErrorMessage: 'Please select language.',
      selectMeditationImageErrorMessage: 'Please select the meditation image.',
      selectExpertErrorMessage: 'Please select expert.'
    }
  }
};

export const soundPageData = {
  metaTitle: 'Sleep | Shoorah Admin',
  pageTitle: 'Sounds',
  sleepTitle: 'Sleep',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by sleep or expert name',
  adminList: { name: 'Select Admin', value: '' },
  tableHeaderText: {
    listenAudio: 'Listen Audio',
    sleepName: 'Sleep Name',
    duration: 'Duration',
    approvalStatus: 'Approval Status',
    expertName: 'Expert Name',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    playedMinutes: 'Played Minutes',
    mostlyPlayed: 'Mostly Played',
    rating: 'Rating',
    status: 'Status'
  },
  listBtnText: 'List',
  draftBtnText: 'Drafts',
  addNewBtnText: 'Add New',
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    statusLabel: 'Status',
    approvalStatusLabel: 'Approval status',
    createdByLabel: 'Created by',
    approvedByLabel: 'Approved By'
  },
  addEditSoundPageData: {
    mainPageTitle: 'Sleep',
    addSleepMetaTitle: 'Add Sleep | Shoorah Admin',
    viewSleepMetaTitle: 'View Sleep | Shoorah Admin',
    editSleepMetaTitle: 'Edit Sleep | Shoorah Admin',
    addSleepPageTitle: 'Add Sleep',
    editSleepPageTitle: 'Edit Sleep',
    viewSleepPageTitle: 'View Sleep',
    sleepNameRequriedErrorMessage: 'Sleep name is required.',
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    fileShouldBeLessThan1MB: 'File size should be less than 1MB',
    uploadAudioFileErrorMessageBeforeName: 'The specified file ',
    uploadAudioFileErrorMessageAfterName:
      ' could not be uploaded. Please upload a valid audio file.',
    uploadSrtFileErrorMessageBeforeName: 'The specified file ',
    uploadSrtFileErrorMessageAfterName:
      ' could not be uploaded. Please upload valid caption srt file.',
    captionFileUpdatedSuccessMessage: 'Caption file updated successfully.',
    captionFileNotUpdatedErrorMessage: 'Caption file not updated.',
    sleepNameLabel: 'Sleep Name',
    sleepNamePlaceholder: 'Enter Sleep Name',
    sleepImageText: 'Sleep Image',
    sleepImageSize: '(Upload 512px * 512px image) (Max image size 1MB)',
    dropYourImageText: 'Drop your image here, or',
    browseText: 'browse',
    imageSupprotFileType: 'Supports: JPG, JPEG, PNG, GIF File',
    selectExpertLabel: 'Select Expert',
    selectCategoriesLabel: 'Select Categories',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter Description',
    statusLabel: 'Status',
    addAudioBtnText: 'Add Audio',
    audioLanguageLabel: 'Audio Language',
    uploadAudioLabel: 'Upload Audio',
    uploadBtnText: 'Upload',
    durationLabel: 'Duration',
    downloadCaptionFileLabel: 'Download Caption file',
    updateCaptionFileLabel: 'Update Caption file',
    cancelBtnText: 'Cancel',
    saveDraftBtnText: 'Save Draft',
    submitForApprovalBtnText: 'Submit For Approval',
    submitBtnText: 'Submit',
    viewTitle: 'View',
    updateSleepDetailsConfirmMessage: 'Are you sure you want to update sleep details?',
    validationMessages: {
      enterNameErrorMessage: 'Please enter the name.',
      enterDescriptionErrorMessage: 'Please enter the description.',
      selectCategoryErrorMessage: 'Please select the category.',
      selectAudioErrorMessage: 'Please select the audio.',
      selectFileErrorMessage: 'Please select the file.',
      selectLanguageErrorMessage: 'Please select language.',
      selectSoundImageErrorMessage: 'Please select the sound image.',
      selectExpertErrorMessage: 'Please select expert.'
    }
  }
};

export const shoorahPodsPageData = {
  pageTitle: 'Shoorah Pods',
  metaTitle: 'Shoorah Pods | Shoorah Admin',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by pod or expert name',
  adminList: { name: 'Select Admin', value: '' },
  tableHeaderText: {
    listenAudio: 'Listen Audio',
    podsName: 'Pods Name',
    duration: 'Duration',
    approvalStatus: 'Approval Status',
    expertName: 'Expert Name',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    playedMinutes: 'Played Minutes',
    mostlyPlayed: 'Mostly Played',
    rating: 'Rating',
    status: 'Status'
  },
  listBtnText: 'List',
  draftBtnText: 'Drafts',
  addNewBtnText: 'Add New',
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    statusLabel: 'Status',
    approvalStatusLabel: 'Approval status',
    createdByLabel: 'Created by',
    approvedByLabel: 'Approved By'
  },
  addEditShoorahPodsPageData: {
    mainPageTitle: 'Shoorah Pods',
    addPodsPageTitle: 'Add Shoorah Pods',
    editPodsPageTitle: 'Edit Shoorah Pods',
    viewPodsPageTitle: 'View Shoorah Pods',
    addPodsMetaTitle: 'Add Shoorah Pods | Shoorah Admin',
    editPodsMetaTitle: 'Edit Shoorah Pods | Shoorah Admin',
    viewPodsMetaTitle: 'View Shoorah Pods | Shoorah Admin',
    podsNameIsrequriedErrorMessage: 'Pod name is required.',
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    fileShouldBeLessThan1MB: 'File size should be less than 1MB',
    uploadAudioFileErrorMessageBeforeName: 'The specified file ',
    uploadAudioFileErrorMessageAfterName:
      ' could not be uploaded. Please upload a valid audio file.',
    uploadSrtFileErrorMessageBeforeName: 'The specified file ',
    uploadSrtFileErrorMessageAfterName:
      ' could not be uploaded. Please upload valid caption srt file.',
    captionFileUpdatedSuccessMessage: 'Caption file updated successfully.',
    captionFileNotUpdatedErrorMessage: 'Caption file not updated.',
    shoorahPodNameLabel: 'Shoorah Pod Name',
    shoorahPodNamePlaceholder: 'Enter Shoorah Pod Name',
    shoorahPodImageLabel: 'Shoorah Pod Image',
    shoorahPodImageSize: '(Upload 512px * 512px image) (Max image size 1MB)',
    dropYourImageText: 'Drop your image here, or',
    browseText: 'browse',
    imageSupprotFileType: 'Supports: JPG, JPEG, PNG, GIF File',
    selectExpertLabel: 'Select Expert',
    selectCategoriesLabel: 'Select Categories',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter Description',
    statusLabel: 'Status',
    addAudioBtnText: 'Add Audio',
    audioLanguageLabel: 'Audio Language',
    uploadAudioLabel: 'Upload Audio',
    uploadBtnText: 'Upload',
    durationLabel: 'Duration',
    downloadCaptionFileLabel: 'Download Caption file',
    updateCaptionFileLabel: 'Update Caption file',
    cancelBtnText: 'Cancel',
    saveDraftBtnText: 'Save Draft',
    submitForApprovalBtnText: 'Submit For Approval',
    submitBtnText: 'Submit',
    viewTitle: 'View',
    updatePodDetailsConfirmMessage: 'Are you sure you want to update pod details?',
    validationMessages: {
      enterNameErrorMessage: 'Please enter the name.',
      enterDescriptionErrorMessage: 'Please enter the description.',
      selectCategoryErrorMessage: 'Please select the category.',
      selectAudioErrorMessage: 'Please select the audio.',
      selectFileErrorMessage: 'Please select the file.',
      selectLanguageErrorMessage: 'Please select language.',
      selectShoorahPodImageErrorMessage: 'Please select the shoorah pod image.',
      selectExpertErrorMessage: 'Please select expert.'
    }
  }
};

export const ritualsPageData = {
  pageTitle: 'Habits',
  metaTitle: 'Habits | Shoorah Admin',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by habit name',
  adminList: { name: 'Select Admin', value: '' },
  tableHeaderText: {
    ritualsName: 'Habit Name',
    approvalStatus: 'Approval Status',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    status: 'Status'
  },
  listBtnText: 'List',
  draftBtnText: 'Drafts',
  addNewBtnText: 'Add New',
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    statusLabel: 'Status',
    approvalStatusLabel: 'Approval status',
    createdByLabel: 'Created by',
    approvedByLabel: 'Approved By'
  },
  addEditRitualsPageData: {
    mainPageTitle: 'Habits',
    addRitualsPageTitle: 'Add Habit',
    editRitualsPageTitle: 'Edit Habit',
    viewRitualsPageTitle: 'View Habit',
    addRitualsMetaTitle: 'Add Habit | Shoorah Admin',
    editRitualsMetaTitle: 'Edit Habit | Shoorah Admin',
    viewRitualsMetaTitle: 'View Habit | Shoorah Admin',
    ritualNameIsRequriedErrorMessage: 'Habit name is required.',
    ritualNameLabel: 'Habit Name',
    selectCategoryLabel: 'Select Category',
    habitIconLabel: 'Habit Icon',
    uploadIconBtnText: 'Upload Icon',
    iconRequiredErrorMessage: 'Habit icon is required.',
    categoryRequiredErrorMessage: 'At least one category is required.',
    createHabitBtnText: 'Create Habit',
    updateHabitBtnText: 'Update Habit',
    createHabitConfirmMessage: 'Are you sure you want to create this habit?',
    statusLabel: 'Status',
    cancelBtnText: 'Cancel',
    saveDraftBtnText: 'Save Draft',
    submitForApprovalBtnText: 'Submit For Approval',
    submitBtnText: 'Submit',
    viewTitle: 'View',
    ritualDetailsUpdateConfirmMessage: 'Are you sure you want to update habit details?',
    validationMessages: {
      enterTitleErrorMessage: 'Please enter the title.',
      selectCategoryErrorMessage: 'Please select the Category.'
    }
  }
};

export const visionIdeasPageData = {
  metaTitle: 'Vision Ideas | Shoorah Admin',
  pageTitle: 'Vision Ideas',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by vision ideas name',
  adminList: { name: 'Select Admin', value: '' },
  tableHeaderText: {
    ideaName: 'Idea Name',
    approvalStatus: 'Approval Status',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    status: 'Status'
  },
  listBtnText: 'List',
  draftBtnText: 'Drafts',
  addNewBtnText: 'Add New',
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    statusLabel: 'Status',
    approvalStatusLabel: 'Approval status',
    createdByLabel: 'Created by',
    approvedByLabel: 'Approved By'
  },
  addEditVisionIdeasPageData: {
    mainPageTitle: 'Vision Ideas',
    addVisionIdeasPageTitle: 'Add Vision Ideas',
    editVisionIdeasPageTitle: 'Edit Vision Ideas',
    viewVisionIdeasPageTitle: 'View Vision Ideas',
    addVisionIdeasMetaTitle: 'Add Vision Ideas | Shoorah Admin',
    editVisionIdeasMetaTitle: 'Edit Vision Ideas | Shoorah Admin',
    viewVisionIdeasMetaTitle: 'View Vision Ideas | Shoorah Admin',
    ideaNameIsRequriedErrorMessage: 'Idea name is required.',
    ideaNameLabel: 'Idea Name',
    statusLabel: 'Status',
    cancelBtnText: 'Cancel',
    saveDraftBtnText: 'Save Draft',
    submitForApprovalBtnText: 'Submit For Approval',
    submitBtnText: 'Submit',
    viewTitle: 'View',
    visionIdeasUpdateConfirmMessage: 'Are you sure you want to update vision ideas details?',
    enterTitleErrorMessage: 'Please enter the title.'
  }
};

export const breathworkPageData = {
  metaTitle: 'Breathwork | Shoorah Admin',
  pageTitle: 'Breathworks',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by breathwork or expert name',
  adminList: { name: 'Select Admin', value: '' },
  tableHeaderText: {
    listenAudio: 'Listen Audio',
    breathworkName: 'Breathwork Name',
    duration: 'Duration',
    approvalStatus: 'Approval Status',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    rating: 'Rating',
    status: 'Status'
  },
  listBtnText: 'List',
  draftBtnText: 'Drafts',
  addNewBtnText: 'Add New',
  basicBreathworkBtnText: 'Basic Breathwork',
  normalBreathworkBtnText: 'Normal Breathwork',
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    statusLabel: 'Status',
    approvalStatusLabel: 'Approval status',
    createdByLabel: 'Created by',
    approvedByLabel: 'Approved By',
    breathworkCategory: 'Breathwork Category'
  },
  addEditBreathworkPageData: {
    categoryList: [
      { label: 'Calm', value: '1' },
      { label: 'Sleep', value: '2' },
      { label: 'Energise', value: '3' },
      { label: 'Focus', value: '4' }
    ],
    mainPageTitle: 'Breathwork',
    addBreathworkPageTitle: 'Add Breathwork',
    editBreathworkPageTitle: 'Edit Breathwork',
    viewBreathworkPageTitle: 'View Breathwork',
    addBreathworkMetaTitle: 'Add Breathwork | Shoorah Admin',
    editBreathworkMetaTitle: 'Edit Breathwork | Shoorah Admin',
    viewBreathworkMetaTitle: 'View Breathwork | Shoorah Admin',
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    fileShouldBeLessThan1MB: 'File size should be less than 1MB',
    uploadAudioFileErrorMessageBeforeName: 'The specified file ',
    uploadAudioFileErrorMessageAfterName:
      ' could not be uploaded. Please upload a valid audio file.',
    uploadSrtFileErrorMessageBeforeName: 'The specified file ',
    uploadSrtFileErrorMessageAfterName:
      ' could not be uploaded. Please upload valid caption srt file.',
    captionFileUpdatedSuccessMessage: 'Caption file updated successfully.',
    captionFileNotUpdatedErrorMessage: 'Caption file not updated.',
    breathworkNameLabel: 'Breathwork Name',
    breathworkNamePlaceholder: 'Enter Breathwork Name',
    breathworkImageLabelWithSize:
      'Breathwork Image (Upload 512px * 512px image) (Max image size 1MB)',
    breathworkImageLabel: 'Breathwork Image',
    dropYourImageText: 'Drop your image here, or',
    browseText: 'browse',
    imageSupprotFileType: 'Supports: JPG, JPEG, PNG, GIF File',
    selectLottieFileLabel: 'Select Lottie File',
    isBasicFrameworkLabel: 'Is Basic Breathwork',
    selectExpertLabel: 'Select Expert',
    selectCategoriesLabel: 'Select Categories',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter Description',
    statusLabel: 'Status',
    addAudioBtnText: 'Add Audio',
    audioLanguageLabel: 'Audio Language',
    uploadAudioLabel: 'Upload Audio',
    uploadBtnText: 'Upload',
    durationLabel: 'Duration',
    downloadCaptionFileLabel: 'Download Caption file',
    updateCaptionFileLabel: 'Update Caption file',
    cancelBtnText: 'Cancel',
    saveDraftBtnText: 'Save Draft',
    submitForApprovalBtnText: 'Submit For Approval',
    submitBtnText: 'Submit',
    viewTitle: 'View',
    updateBreathworkDetailsConfirmMessage: 'Are you sure you want to update breathwork details?',
    validationMessages: {
      enterNameErrorMessage: 'Please enter the name.',
      enterDescriptionErrorMessage: 'Please enter the description.',
      selectCategoryErrorMessage: 'Please select the category.',
      selectAudioErrorMessage: 'Please select the audio.',
      selectFileErrorMessage: 'Please select the file.',
      selectLanguageErrorMessage: 'Please select language.',
      selectExpertErrorMessage: 'Please select expert.'
    }
  }
};

export const healthVideosPageData = {
  metaTitle: 'Health Videos | Shoorah Admin',
  pageTitle: 'Health Videos',
  perPageText: 'Per Page',
  searchPlaceholder: 'Search by video or expert name',
  liveVideosLabel: 'Live Videos',
  videoWatchContLabel: 'Video Watch Count',
  mostPopularTopicLabel: 'Most Popular Topic',
  timesLabel: 'times',
  leastUsedTopicLabel: 'Least Used Topic',
  adminList: { name: 'Select Admin', value: '' },
  tableHeaderText: {
    name: 'Name',
    duration: 'Duration',
    approvalStatus: 'Approval Status',
    expertName: 'Expert Name',
    createdBy: 'Created By',
    approvedBy: 'Approved By',
    createdOn: 'Created On',
    approvedOn: 'Approved On',
    playedMinutes: 'Played Minutes',
    mostPlayed: 'Mostly Played',
    status: 'Status'
  },
  listBtnText: 'List',
  draftBtnText: 'Drafts',
  addNewBtnText: 'Add New',
  filtersModal: {
    filtersBtnText: 'Filters',
    resetFiltersBtnText: 'Reset Filter',
    closeBtnText: 'Close',
    statusLabel: 'Status',
    approvalStatusLabel: 'Approval status',
    createdByLabel: 'Created by',
    approvedByLabel: 'Approved By',
    selectCategoryLabel: 'Select Category'
  },
  addEditHealthVideosPageData: {
    mainPageTitle: 'Health Video',
    addHealthVideoPageTitle: 'Add Health Video',
    editHealthVideoPageTitle: 'Edit Health Video',
    viewHealthVideoPageTitle: 'View Health Video',
    addHealthVideoMetaTitle: 'Add Health Video | Shoorah Admin',
    editHealthVideoMetaTitle: 'Edit Health Video | Shoorah Admin',
    viewHealthVideoMetaTitle: 'View Health Video | Shoorah Admin',
    pageTypes: [
      { name: 'Details', value: 'details' },
      { name: 'Content', value: 'content' },
      { name: 'Audience', value: 'audience' }
    ],
    videoTypeOptions: [
      { label: 'iframe', value: 1 },
      { label: 'video', value: 2 }
    ],
    selectedAudienceOptions: [
      { label: 'B2B', value: 1 },
      { label: 'Mobile', value: 2 }
    ],
    continueBtnText: 'Continue',
    clickHerText: 'Click here ',
    uploadOrDropMediaText: 'to upload or drop media here',
    uploadVideoLabel: 'Upload Video',
    validVideoErrorMessageBeforeFileName: 'The specified file',
    validVideoErrorMessageafterFileName: 'could not be uploaded. Please upload valid video.',
    fileShouldBeLessThan500MB: 'File size should be less than 500MB',
    videoUploadedSuccessfully: 'Tutorial video uploaded successfully.',
    saveAsDraftBtnText: 'Save as draft',
    submitBtnText: 'Submit',
    selectAudienceText: 'Select Audience',
    durationLabel: 'Duration',
    wherevideosShownQuestionText: 'Where would you like to show this video?',
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    fileShouldBeLessThan1MB: 'File size should be less than 1MB',
    thumbnailLabel: 'Thumbnail',
    thumbnailSize: '(Upload 512px * 512px image) (Max image size 1MB)',
    dropYourImageText: 'Drop your image here, or',
    browseText: 'browse',
    imageSupprotFileType: 'Supports: JPG, JPEG, PNG, GIF File',
    thumbnailImageLabel: 'Thumbnail Image',
    videoIDLabel: 'Video ID',
    videoIDPlaceholder: 'Enter Video ID',
    selectAudienceErrorMessage: 'Please select audience type',
    videoNameRequriedMessage: 'Video name is required.',
    unsupportedVideoFormatMessage: 'Unsupported video format.',
    nameLabel: 'Name',
    namePlaceholder: 'Enter Name',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter Description',
    statusLabel: 'Status',
    selectExpertLabel: 'Select Expert',
    selectCategoriesLabel: 'Select Categories',
    selectVideoTypeText: 'Select video type',
    cancelBtnText: 'Cancel',
    saveDraftBtnText: 'Save Draft',
    submitForApprovalBtnText: 'Submit For Approval',
    viewTitle: 'View',
    updateVideoDetailsConfrimMessage: 'Are you sure you want to update video details?',
    validationMessages: {
      enterNameErrorMessage: 'Please enter the name.',
      enterDescriptionErrorMessage: 'Please enter the description.',
      selectCategoryErrorMessage: 'Please select the category.',
      enterVideoIdErrorMessage: 'Please enter the video id.',
      selectFileErrorMessage: 'Please select the file.',
      selectThumbnailErrorMessage: 'Please select the thumbnail.',
      selectExpertErrorMessage: 'Please select expert.',
      selectVideoTypeErrorMessage: 'please select video type',
      videoTypeOptions: [
        { label: 'iframe', value: 1 },
        { label: 'video', value: 2 }
      ],
      selectedAudienceOptions: [
        { label: 'B2B', value: 1 },
        { label: 'Mobile', value: 2 }
      ],
      selectAudienceErrorMessage: 'Please select audience type'
    }
  }
};

export const marketplacePageData = {
  pageTitle: 'Marketplace',
  metaTitle: 'Marketplace | Shoorah Admin',
  searchPlaceholder: 'Search',
  createBtnText: 'Create',
  addCompanyBtnText: 'Add Company',
  viewCompaniesBtnText: 'View Companies',
  addOfferingBtnText: 'Add Offering',
  activeOfferingText: 'Active Offerings',
  expiringOffersText: 'Expiring Offers',
  totalURLClicksText: 'Total URL Clicks',
  activeMarketPlaceOfferingsTitle: 'Active Marketplace Offerings',
  mostPopularActiveOffersTitle: 'Most Popular Active Offers',
  draftTitle: 'Drafts',
  somethingWentWrongErrorMessage: 'Something went wrong, please try again later !',
  companyInstantSupportStatus: {
    0: 'Created',
    1: 'In Progress',
    2: 'Approved',
    3: 'Rejected',
    4: 'Disabled'
  },
  supportPaymentStatus: {
    0: 'Failed',
    1: 'Paid',
    2: 'In Progress'
  },
  createNewCompanyOfferSectionData: {
    pageData: 'Marketplace ',
    metaTitle: 'Marketplace | Shoorah Admin'
  },
  addCompanyPageData: {
    failedToGetCompanyInformationErrorMessage: 'Failed to get company information',
    errorOccuredWhileFetchCompanyInformationMessage:
      'An error occurred while fetching company information',
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    fileShouldBeLessThan1MB: 'File size should be less than 1MB',
    companyTitleRequriedErrorMessage: 'Company Title is required',
    companyURLRequriedErrorMessage: 'Company URL is required',
    companyEmailIdIsRequriedErrorMessage: 'Company Email ID is required',
    companyLegalsIsRequriedErrorMessage: 'Company Legals is required',
    enterValidEmailAddressErrorMessage: 'Please enter a valid email address',
    createCompanyLabel: 'Create Company',
    editCompanyLabel: 'Edit Company',
    previewBtnText: 'Preview',
    companyImageTitle: 'Company Image',
    dropTheBrandText: 'Drop the brand',
    imageText: 'image',
    hereText: 'here',
    selectedText: 'Selected:',
    imageSizeInKBLabel: 'KB',
    companyTitleLabel: 'Company Title',
    companyTitlePlaceholder: 'Enter company title',
    entercompanyUrlLabel: 'Enter Company URL',
    enterCompanyUrlPlaceholder: 'Enter company URL',
    companyLegalsLabel: 'Company Legals',
    companyLegalsPlaceholder: 'Enter your Company Legals',
    characterLengthForCompanyLegals: '/5000 characters',
    companyEmailIdLabel: 'Company Email ID',
    companyEmailIdPlaceholder: 'Enter company email ID',
    commissionLabel: 'Commission',
    commissionPlaceholder: 'e.g., 5%, 10% flat, Variable commission',
    commissionExampleText:
      'Enter commission details (e.g., "5%", "10% flat rate", "Variable based on sales")',
    commissionDescriptionLabel: 'Company Description',
    commissionDescriptionPlaceholder: 'Enter Description',
    characterLengthForCommissionDescription: '/500 characters'
  },
  addOffersPageData: {
    onlyUploadUpTo10ImagesErrorMessage: 'You can only upload up to 10 images',
    somethingWentWrongInGettingOfferCategoiesErrorMessage:
      'Something went wrong in getting offer catagories, please try again later !',
    somethingWentWrongErrorMessage: 'Something went wrong, please try again later !',
    failedToLoadMarketplaceCompaniesMessage: 'Failed to load marketplace companies',
    failedToSearchCompaniesMessage: 'Failed to search companies',
    failedToLoadOfferInformationMessage: 'Failed to load offer information',
    selectAMarketplaceCompanyErrorMessage: 'Please select a Marketplace Company',
    offerTitleRrequriedErrorMessage: 'Offering Title is required',
    offerCategoryRequriedErrorMessage: 'Offering Category is required',
    offerUrlRequriedErrorMessage: 'Offer URL is required',
    issueWithImageErrorMessage: 'There was an issue with the image. Using fallback method.',
    fileSizeLessThan100MbMessage: 'File size should be less than 100MB',
    validVideoErrorMessageBeforeFileName: 'The specified file',
    validVideoErrorMessageafterFileName: 'could not be uploaded. Please upload valid video file.',
    logoFileSizeLessThan5Mb: 'Logo file size should be less than 5MB',
    validLogoImageErrorMessageBeforeName: 'The specified file',
    validLogoImageErrorMessageAfterName: 'could not be uploaded. Please upload a valid logo image.',
    createOfferLabel: 'Create Offer',
    editOfferLabel: 'Edit Offer',
    prieviewOfferingBtnText: 'Preview Offering',
    offerLogoLabel: 'Offer Logo',
    dropTheOfferText: 'Drop the offer',
    logoText: 'logo',
    hereText: 'here',
    dropTheBrandText: 'Drop the brand',
    fileText: 'file',
    dropTheVideo: 'Drop the video',
    imageText: 'image',
    imageSelectedText: 'selected',
    attachmentBtnText: 'Attachment',
    selectedText: 'Selected:',
    imageFileType: 'KB',
    offerImageLabel: 'Offer Image',
    promoVideoLabel: 'Promo Video',
    selectCompanyLabel: 'Select Company',
    selectCompanyPlaceholder: 'Search for a company',
    noCompanyFoundMessage: 'No companies found',
    loadingMoreCompanyText: 'Loading more companies...',
    offeringTitleLabel: 'Offering Title',
    offeringTitlePlaceholder: 'Enter Offering Title',
    offeringTitleMaxCharacterText: '/120 characters',
    expiryDateLabel: 'Expiry Date',
    offerNeverExpiredLabelMessage: 'This offer never expires (Unlimited time)',
    neverExpiredLabel: 'Never expires (Unlimited)',
    selectExpiryDateLabel: 'Select Expire Date',
    validFromDateLabel: 'Valid From Date',
    offerBecomeAvailabelMessage:
      'When should this offer become available? Leave empty for immediate availability.',
    selectValidFromDateLabel: 'Select Valid From Date (Optional)',
    clearImmediateAvailabilityBtnText: 'Clear (Immediate availability)',
    offerUrlLabel: 'Offer URL',
    offerUrlPlaceholder: 'Enter URL',
    offerCodeLabel: 'Offer Code',
    offerCodePlaceholder: 'Enter code',
    offerCodeCharacterLength: '/30 characters',
    specialOfferLabel: 'Special Offer',
    specialOfferPlaceholder: 'Special offers will be highlighted in the marketplace',
    offeringCategoryLabel: 'Offering Category',
    selectCategoriesText: 'Select categories',
    noCategoriesAvailableMessage: 'No categories available',
    discountRateLabel: 'Discount Rate',
    discountRatePlaceholderText:
      'Enter any discount text (e.g., "50% OFF", "Buy 1 Get 1 Free", "$10 OFF")',
    discountRatePlaceholder: 'e.g., 50% OFF, Buy 1 Get 1 Free, $10 OFF',
    redeemTimeLabel: 'Redeem Time',
    redeemTimePlaceholder: 'e.g., 24 hours, 3-5 business days, Instantly, Within 1 week',
    redeemTimePlaceholderText:
      'Enter any redeem time description (e.g., "24 hours", "3-5 business days", "Instantly")',
    offeringDescriptionLabel: 'Offering Description',
    offeringDescriptionPlaceholder: 'Enter Description',
    offeringDescriptionCharacterLength: '/720 characters'
  },
  companyPreviewPagedata: {
    failedToLoadPreviewDataErrorMessage: 'Failed to load preview data',
    companyTitleRequriedErrorMessage: 'Company Title is required',
    companyURLRequriedErrorMessage: 'Company URL is required',
    companyEmailIdIsRequriedErrorMessage: 'Company Email ID is required',
    companyLegalsIsRequriedErrorMessage: 'Company Legals is required',
    enterValidEmailIDErrorMessage: 'Please enter a valid Email ID',
    companySavedButImageUploadFailedMessage: 'Company saved but image upload failed',
    companyUpdateSuccessMessage: 'Company updated successfully',
    companyCreateSuccessMessage: 'Company created successfully',
    errorOccuredWhileSavingCompanyMessage: 'An error occurred while saving company',
    failedToSaveCompanyErrorMessage: 'Failed to save company. Please try again.',
    pageTitle: 'Company Preview',
    backToEditortBtnText: 'Back to editor',
    companyImageLabel: 'Company Image',
    dropTheOfferText: 'Drop the offer',
    logoText: 'logo',
    hereText: 'here',
    dropTheBrandText: 'Drop the brand',
    fileText: 'file',
    dropTheVideo: 'Drop the video',
    imageText: 'image',
    imageSelectedText: 'selected',
    attachmentBtnText: 'Attachment',
    selectedText: 'Selected:',
    imageFileType: 'KB',
    companyTitleLabel: 'Company Title',
    companyUrlLabel: 'Company URL',
    companyUrlPlaceholder: 'Enter company URL',
    companyLegalsLabel: 'Company Legals',
    companyEmailIDLabel: 'Company Email ID',
    companyEmailIdPlaceholder: 'Enter company email ID',
    commissionLabel: 'Commission',
    commissionPlaceholder: 'Commission details',
    companyDescriptionLabel: 'Company Description',
    updateCompanyBtnText: 'Update Company',
    addCompanyBtnText: 'Add Company'
  },
  createNewOfferingPageData: {
    marketplacePageTitle: 'Marketplace',
    metaTitle: 'Marketplace | Shoorah Admin',
    previewOfferingPageTitle: 'Preview Offering',
    newCompanyPageTitle: 'New Company',
    createCompanyLabel: 'Create Company',
    offerDetailsLabel: 'Offer Details',
    previewOfferingLabel: 'Preview Offering',
    continueBtnText: 'Preview Offering',
    submitBtnText: 'Submit'
  },
  insightsPageData: {
    weeklyUsageLabel: 'Weekly Usage',
    somethingWentWrongWhileFetchingInsightsMessage:
      'Something went wrong while fetching Offer Insights',
    companyNameTitle: 'Company Name',
    commissionTitle: 'Commission',
    companyEmailTitle: 'Company Email',
    totalClicksTitle: 'Total Clicks',
    clickThroughRateTitle: 'Click-Through Rate',
    totalUrlClicksTitle: 'Total URL Clicks',
    downText: '% vs last 30 days',
    pageTitle: 'Offer Insights',
    usersText: 'users',
    last7DaysText: 'Last 7 Days',
    dropOffPointText: 'Drop-off point',
    offerText: 'Offer',
    urlLabel: 'URL',
    couponLabel: 'Coupon',
    prOfUsersDropOffText: 'Percentage of users dropped off'
  },
  viewCompaniesPageData: {
    metaTitle: 'Marketplace | Shoorah Admin',
    pageTitle: 'Marketplace Company',
    marketplacePageTitle: 'Marketplace',
    searchPlaceholder: 'Search',
    tableHeaderText: {
      companyProfile: 'Company Profile',
      description: 'Description',
      url: 'URL',
      commission: 'Commission',
      createdOn: 'Created On',
      status: 'Status'
    },
    somethingWentWrongErrorMessage: 'Something went wrong, please try again later !',
    numberMustBeExaclty15Digits: 'Number must be exactly 15 digits',
    enterValidAllocatedNumberOf15DigitsMessage:
      'Please enter a valid Allocated number of 15 digits',
    supportAddedSuccessMessage: 'Support added successfully',
    companyDeleteSuccessMessage: 'Company deleted successfully',
    somethingWhenWrongWhileDeleteCompanyMessage: 'Something went wrong while deleting the company',
    activeLabel: 'Active',
    inActiveLabel: 'Inactive',
    createBtnText: 'Create',
    addCompanyBtnText: 'Add Company',
    viewOfferingsBtnText: 'View Offerings',
    addOfferingsBtnText: 'Add Offering'
  },
  viewOffersPageData: {
    metaTitle: 'Marketplace | Shoorah Admin',
    marketplacePageTitle: 'Marketplace',
    activeOffersPaageTitle: ' Active Offers',
    draftOffersPageTitle: ' Draft Offers',
    popularOffersPageTitle: ' Popular Offers',
    expiredOffersPageTitle: ' Expired Offers',
    upcomingOffersPageTitle: ' Upcoming Offers',
    marketplaceOffersPageTitle: 'Marketplace Offers',
    creatorsList: { name: 'All', value: '' },
    getStatusText: {
      draft: 'Draft',
      expired: 'Expired',
      upcoming: 'Upcoming',
      active: 'Active',
      popular: 'Popular'
    },
    tableHeaderText: {
      offerDetails: 'Offer Details',
      company: 'Company',
      description: 'Description',
      discount: 'Discount',
      redeemTime: 'Redeem Time',
      code: 'Code',
      clickCount: 'Click Count',
      createdOn: 'Created On',
      status: 'Status',
      viewInsights: 'View Insights'
    },
    somethingWentWrongErrorMessage: 'Something went wrong, please try again later !',
    companyDeleteSuccessMessage: 'Company deleted successfully',
    somethingWhenWrongWhileDeleteCompanyMessage: 'Something went wrong while deleting the company',
    viewInsightsLabel: 'View Insights',
    activeOfferingsTitle: 'Active Offerings',
    expiringOffersTitle: 'Expiring Offers',
    totalUrlClicksTitle: 'Total URL Clicks',
    perPageText: 'Per Page',
    searchPlaceholder: 'Search by offer name and description',
    createBtnText: 'Create',
    addCompanyBtnText: 'Add Company',
    viewCompanyBtnText: 'View Company',
    addOfferingsBtnText: 'Add Offering',
    filtersModal: {
      filtersBtnText: 'Filters',
      resetFiltersBtnText: 'Reset Filter',
      closeBtnText: 'Close',
      offerStatusLabel: 'Offer status',
      offerStatusMenuList: [
        { name: 'Active', value: 0 },
        { name: 'Draft', value: 1 },
        { name: 'Popular', value: 2 },
        { name: 'Expired', value: 3 },
        { name: 'Upcoming', value: 4 }
      ],
      createdByLabel: 'Created By'
    }
  },
  previewPageData: {
    onlyUploadUpTo10IMagesMessage: 'You can only upload up to 10 images',
    fileErrorMessageBeforeName: 'File',
    fileErrorMessageAfterName: ' is too large. File size should be less than 1MB',
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    videoFileSizeMustBe10MB: 'Video file size should be less than 10MB',
    validVideoErrorMessageBeforeFileName: 'The specified file',
    validVideoErrorMessageafterFileName: 'could not be uploaded. Please upload a valid video file.',
    failedToGetCompanyInformationErrorMessage: 'Failed to get company information',
    errorOccuredWhileFetchCompanyInformationMessage:
      'An error occurred while fetching company information',
    offerWasCreatedButSomeImagesAreMissingMessage:
      'image(s) failed to upload. The offer was created but some images may be missing.',
    videoFailedToUploadErrorMessage: 'Video failed to upload, but offer was created',
    logoFailedToUploadErrorMessage: 'Logo failed to upload, but offer was created',
    offerAddedSuccessMessage: 'Offer added successfully',
    offerUpdatedSuccessMessage: 'Offer updated successfully',
    failedToAddOrUpdateOfferMessage: 'Failed to add/update offer',
    errorProcessingOfferMessageBeforeMessage: 'Error processing offer: ',
    errorSavingDraftErrorMessage: 'Error saving draft: ',
    errorProcessingOfferMessageAfterMessage: 'Unknown error',
    imageFailedToUploadErrorMessage:
      'image(s) failed to upload. The draft was saved but some images may be missing.',
    videoFailedToUploadDraftWasSavedErrorMessage: 'Video failed to upload, but draft was saved',
    logoFailedToUploadDraftSavedErrorMessage: 'Logo failed to upload, but draft was saved',
    offerSavedAsDraftSuccessmessage: 'Offer saved as draft',
    draftUpdatedSuccessMessage: 'Draft updated successfully',
    failedToUpdateDraftErrorMessage: 'Failed to save/update draft',
    companyDetailsLabel: 'Company Details',
    offerDetailsLabel: 'Offer Details',
    backToEditortBtnText: 'Back to editor',
    offerLogoLabel: 'Offer Logo',
    noLogoText: 'No logo',
    selectedText: 'selected',
    offerImagesLabel: 'Offer Images',
    offerVideoLabel: 'Offer Video',
    fileText: 'file',
    dropTheVideo: 'Drop the video',
    hereText: 'here',
    selectedLabelText: 'Selected:',
    imageFileType: 'KB',
    companyNameLabel: 'Company Name',
    offeringTitleLabel: 'Offering Title',
    expiryDateLabel: 'Expiry Date',
    neverExpiredLabel: 'Never expires (Unlimited)',
    noExpirydataSetLabel: 'No expiry date set',
    validFromDateLabel: 'Valid From Date',
    availableFromLabel: 'Available from:',
    availableImmediatelyLabel: 'Available immediately',
    offerUrlLabel: 'Offer URL',
    offerCodeLabel: 'Offer Code',
    specialOfferLabel: 'Special Offer',
    specialOfferPlaceholder: 'Special offers will be highlighted in the marketplace',
    offeringCategoryLabel: 'Offering Category',
    noCategoryLabel: 'No categories selected',
    discountRateLabel: 'Discount Rate',
    redeemTimeLabel: 'Redeem Time',
    offeringDescriptionLabel: 'Offering Description',
    draftBtnText: 'Draft',
    addOfferBtnText: 'Add Offer',
    updateOfferBtnText: 'Update Offer'
  }
};

export const horizontalListCardData = {
  viewAllBtnText: 'View All',
  noDataAvailableText: 'No data available',
  discountRateLabel: '% off',
  offerNameTitle: 'Offer Name',
  companyNameTitle: 'Company Name',
  expiredText: 'Expired',
  expireInText: 'Expires in',
  daysText: 'days',
  expireIn24DaysText: 'Expires in 24 days',
  editBtnText: 'Edit',
  viewBtnText: 'View',
  deleteBtnText: 'Delete',
  usedText: 'Used',
  timesText: 'times',
  percentageBtnText: 'Percentage'
};

export const featuresHealthVideosPageData = {
  pageTitle: 'Health Videos',
  metaTitle: 'Health Videos | Shoorah Admin',
  searchPlaceholder: 'Search',
  selectCategoryLabel: 'Please select category',
  categoryLabel: 'Category',
  noVideosLabel: 'No videos available',
  dateCreatedBtnText: 'Date Created',
  addNewVideoBtnText: 'Add New Video',
  avtiveVideosLabel: 'Active Videos',
  totalVideosLabel: 'Total Views',
  userEngagementLabel: 'User engagement',
  topCategoryLabel: 'Top category',
  liveVideosLabel: 'Live Videos',
  videoWatchContLabel: 'Video Watch Count',
  mostPopularTopicLabel: 'Most Popular Topic',
  timesLabel: 'times',
  leastUsedTopicLabel: 'Least Used Topic',
  activeVideosText: 'Active Videos',
  allPicsText: 'All topics',
  todaysTopPicsText: 'Today’s top picks',
  viewAllBtnText: 'View All',
  videoCategory: [
    { name: 'All', value: '' },
    { name: 'Mental-Health', value: 1 },
    { name: 'Anxiety', value: 2 },
    { name: 'Manager', value: 3 }
  ],
  allHealthVideosPageData: {
    pageTitle: 'All Health Videos',
    metaTitle: 'Health Videos | Shoorah Admin',
    searchPlaceholder: 'Search',
    selectCategoryLabel: 'Please select category',
    categoryLabel: 'Category',
    noVideosLabel: 'No videos available',
    dateCreatedBtnText: 'Date Created',
    addNewVideoBtnText: 'Add New Video',
    avtiveVideosLabel: 'Active Videos',
    totalVideosLabel: 'Total Views',
    userEngagementLabel: 'User engagement',
    topCategoryLabel: 'Top category',
    liveVideosLabel: 'Live Videos',
    videoWatchContLabel: 'Video Watch Count',
    mostPopularTopicLabel: 'Most Popular Topic',
    timesLabel: 'times',
    leastUsedTopicLabel: 'Least Used Topic',
    allVideosText: 'All Videos',
    viewAllBtnText: 'View All',
    videoCategory: [
      { name: 'All', value: '' },
      { name: 'Mental-Health', value: 1 },
      { name: 'Anxiety', value: 2 },
      { name: 'Manager', value: 3 }
    ]
  },
  editHealthVideosPageData: {
    pageTitle: 'Health Videos',
    editPageTitle: 'Edit Health Video',
    addPageTitle: 'Add New Health Video',
    viewPageTitle: 'View Health Video',
    addMetaTitle: 'Add Health Videos | Shoorah Admin',
    editMetaTitle: 'Edit Health Videos | Shoorah Admin',
    viewMetaTitle: 'View Health Videos | Shoorah Admin',
    pageTypes: [
      { name: 'Details', value: 'details' },
      { name: 'Content', value: 'content' },
      { name: 'Audience', value: 'audience' }
    ],
    nameLabel: 'Video Title',
    namePlaceholder: 'Enter video title..',
    selectExpertLabel: 'Select Expert',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter Description',
    statusLabel: 'Staus',
    selectCategoriesLabel: 'Video Category',
    continueBtnText: 'Continue',
    clickHerText: 'Click here ',
    uploadOrDropMediaText: 'to upload or drop media here',
    uploadVideoLabel: 'Upload Video',
    validVideoErrorMessageBeforeFileName: 'The specified file',
    validVideoErrorMessageafterFileName: 'could not be uploaded. Please upload valid video.',
    fileShouldBeLessThan500MB: 'File size should be less than 500MB',
    videoUploadedSuccessfully: 'Tutorial video uploaded successfully.',
    saveAsDraftBtnText: 'Save as draft',
    submitBtnText: 'Submit',
    selectAudienceText: 'Select Audience',
    selectedAudienceOptions: [
      { label: 'B2B', value: 1 },
      { label: 'Mobile', value: 2 }
    ],
    durationLabel: 'Duration',
    validImageErrorMessageBeforeFileName: 'The specified file',
    validImageErrorMessageafterFileName: 'could not be uploaded. Please upload valid image.',
    fileShouldBeLessThan1MB: 'File size should be less than 1MB',
    thumbnailLabel: 'Thumbnail',
    thumbnailSize: '(Upload 512px * 512px image) (Max image size 1MB)',
    dropYourImageText: 'Drop your image here, or',
    browseText: 'browse',
    imageSupprotFileType: 'Supports: JPG, JPEG, PNG, GIF File',
    thumbnailImageLabel: 'Thumbnail Image',
    videoIDLabel: 'Video ID',
    videoIDPlaceholder: 'Enter Video ID',
    videoTypeOptions: [
      { label: 'iframe', value: 1 },
      { label: 'video', value: 2 }
    ],
    selectVideoTypeText: 'select video type',
    whereToShowVideoLabel: 'Where would you like to show this video?'
  },
  viewHealthVideosPageData: {
    addedTodayText: 'Added today',
    addedText: 'Added',
    agoText: 'ago',
    metaTitle: 'B2B | View Health Video',
    pageTitle: 'View Health Video'
  }
};

export const shoorahBenefitsPageData = {
  metaTitle: 'B2B | Shoorah Benefits',
  pageTitle: 'Shoorah Benefits',
  pageDescription:
    'A streamlined salary sacrifice solution designed to boost retention, reduce costs, and support modern employee needs.',
  shoorahBenefitsTitle: 'Shoorah Benefits',
  shoorahBenefitsDescription:
    'A streamlined salary sacrifice solution designed to boost retention, reduce costs, and support modern employee needs',
  getBenefitsLabel: 'Get Benefits',
  viewBenefitsLabel: 'View Benefits',
  downloadPDFLabel: 'Download Benefits PDF',
  addCustomBenefitsLabel: 'Add custom benefits',
  adminBenefitsPageData: {
    metaTitle: 'B2B | Shoorah Benefits',
    pageTitle: 'Shoorah Benefits',
    pageDescription:
      'A streamlined salary sacrifice solution designed to boost retention, reduce costs, and support modern employee needs.',
    somethingWentWrongErrorMessage: 'Something went wrong, please try again later !',
    tableHeaderText: {
      comapnyName: 'Company Name',
      companyEmail: 'Company Email',
      planTitle: 'Plan Title',
      dateCreated: 'Date Created',
      planStatus: 'Plan Status',
      action: 'Action'
    },
    companyInstantSupportStatus: {
      0: 'Created',
      1: 'Active',
      2: 'Inactive',
      3: 'Rejected',
      4: 'Disabled'
    },
    failedToUpdateStautsMessage: 'Failed to update status',
    failedToUpdateStatusErrorMessage: 'Failed to update status. Please try again.',
    customPlanText: 'Custom Plan',
    shoorahPlansTitle: 'Shoorah Plans',
    customPlansTitle: 'Custom Plans',
    noPlansTitle: 'No Plans',
    hideCustomLabel: 'Hide Custom',
    viewCustomLabel: 'View Custom',
    searchPlaceholder: 'Search',
    dateRangeLabel: 'Date range',
    addCompanyLabel: 'Add Company'
  },
  viewBenefitsPageData: {
    plansData: [
      {
        title: 'Workplace nursery',
        description:
          'Employees can save thousands annually on nursery fees through gross salary exchange. Enjoy Benefits contributes £1,800 per child per year directly to the partnered nursery',
        planRequirements: [
          'No cost to you',
          'Employees save on Tax and NI',
          'Supports nursery development',
          'Saves you employer NI'
        ]
      },
      {
        title: 'Gym memberships',
        description:
          'Cover gym costs upfront, with employees repaying monthly through salary — and saving on NI.'
      },
      {
        title: 'Cycle to work',
        description:
          'Provide bikes and accessories with no upfront spend. Great for health, wellbeing and commuting.'
      },
      {
        title: 'Car maintenance',
        description:
          'Let staff cover MOTs, tyres or repairs through Halfords and pay monthly via salary deduction.'
      },
      {
        title: 'Mobile tech',
        description: 'Let staff spread the cost of the latest smartphones, sim free and unlocked.'
      },
      {
        title: 'Holiday trading',
        description: 'Staff can buy or sell extra holiday based on their lifestyle needs.'
      },
      {
        title: 'Health cash plans',
        description: 'Cover everyday health costs like dental, optical and physio.'
      },
      {
        title: 'Home technology',
        description: 'Tech and appliances from Currys with monthly salary payments.'
      },
      {
        title: 'Will writing',
        description: 'Peace of mind with expert legal support and lower cost.'
      },
      {
        title: 'Discounts & rewards',
        description: 'Save on shopping, travel, leisure and more.'
      }
    ],
    metaTitle: 'B2B | View Benefits',
    pageTitle: 'View Benefits',
    pageDescription:
      'A streamlined salary sacrifice solution designed to boost retention, reduce costs, and support modern employee needs.',
    showingCustomPlansTitle: 'Showing Custom Plans',
    showCustomPlansTitle: 'Show Custom Plans',
    listOfBenefitsPlansTitle: 'List of Shoorah benefits plan',
    laodingText: 'Loading...',
    noBenefitsAvailableText: 'No benefits available.',
    informationTitle: 'Information',
    contactUsBtnText: 'Contact us'
  },
  addCustomBenefitsPageData: {
    phoneNumberRequriedMessage: 'Phone number is required',
    enterValidNumberMessage: 'Please enter a valid phone number',
    inValidNumberFormatMessage: 'Invalid phone number format',
    urlIsRequriedMessage: 'URL is required',
    enterValidUrlMessage: 'Please enter a valid URL.',
    pleaseEnterPlanTitleMessage: 'Please enter plan details Title',
    pleaseEnterPlanDescriptionMessage: 'Please enter plan details description',
    planTitleMaxcharacterErrorMessage: 'Plan Title must be less than 120 characters',
    planDescriptionMaxcharacterErrorMessage: 'Plan Description must be less than 1200 characters',
    pleaseSelectACompanyErrorMessage: 'Please Select a company',
    customPlanAddedSuccessMessage: 'Custom plan added successfully!',
    somethingWentWrongMessage: 'Something went wrong.',
    failedToAddCustomPlanMessage: 'Failed to add custom plan.',
    metaTitle: 'B2B | Add Custom Shoorah Benefits',
    pageTitle: 'Shoorah Benefits',
    pageDescription:
      'A streamlined salary sacrifice solution designed to boost retention, reduce costs, and support modern employee needs.',
    customBenefitsText: 'custom benefits',
    dropTheBrandtext: 'Drop the brand',
    imageText: 'image',
    hereText: 'here',
    selectedText: 'Selected:',
    imageFileType: 'KB',
    nameLabel: 'Plan Title',
    nameplaceholder: 'Plan title',
    nameRequriedtext: '*Plan Title is required',
    companyNameLabel: 'Company name',
    companyNamePlaceholder: 'Search or select a company',
    searchLabel: 'Searching...',
    loadingMoreText: 'Loading more...',
    loadingText: 'Loading...',
    noCompanyFoundText: 'No companies found',
    emailText: 'Email',
    emailPlaceholder: 'Email',
    emailIsRequriedMessage: '*Email is required',
    invalidEmailAddressMessage: 'Invalid email address',
    phoneNumberLabel: 'Phone number',
    phoneNumberPlaceholder: 'Enter phone number',
    enterValidPhoneNumberMessage: 'Please enter a valid phone number',
    urlText: 'URL',
    urlPlaceholder: 'Enter URL',
    addDetilsLabel: 'Add Details',
    planDetailsTitle: 'Plan details',
    titlePlaceholder: 'Enter title',
    descriptionPlaceholder: 'Enter description',
    addDetailsPlaceholder: 'Add Details',
    addCustomPlansBtnText: 'Add Custom Plan',
    editCustomPlanBtnText: 'Edit Custom Plan',
    addShoorahPlanBtnText: 'Add Shoorah Plan',
    plansData: [
      {
        title: 'Workplace nursery',
        description:
          'Employees can save thousands annually on nursery fees through gross salary exchange. Enjoy Benefits contributes £1,800 per child per year directly to the partnered nursery',
        planRequirements: [
          'No cost to you',
          'Employees save on Tax and NI',
          'Supports nursery development',
          'Saves you employer NI'
        ]
      },
      {
        title: 'Gym memberships',
        description:
          'Cover gym costs upfront, with employees repaying monthly through salary — and saving on NI.'
      },
      {
        title: 'Cycle to work',
        description:
          'Provide bikes and accessories with no upfront spend. Great for health, wellbeing and commuting.'
      },
      {
        title: 'Car maintenance',
        description:
          'Let staff cover MOTs, tyres or repairs through Halfords and pay monthly via salary deduction.'
      },
      {
        title: 'Mobile tech',
        description: 'Let staff spread the cost of the latest smartphones, sim free and unlocked.'
      },
      {
        title: 'Holiday trading',
        description: 'Staff can buy or sell extra holiday based on their lifestyle needs.'
      },
      {
        title: 'Health cash plans',
        description: 'Cover everyday health costs like dental, optical and physio.'
      },
      {
        title: 'Home technology',
        description: 'Tech and appliances from Currys with monthly salary payments.'
      },
      {
        title: 'Will writing',
        description: 'Peace of mind with expert legal support and lower cost.'
      },
      {
        title: 'Discounts & rewards',
        description: 'Save on shopping, travel, leisure and more.'
      }
    ],
    shoorahPlansData: [
      {
        title: 'Workplace nursery',
        description:
          'Employees can save thousands annually on nursery fees through gross salary exchange. Enjoy Benefits contributes £1,800 per child per year directly to the partnered nursery',
        planRequirements: [
          'No cost to you',
          'Employees save on Tax and NI',
          'Supports nursery development',
          'Saves you employer NI'
        ]
      },
      {
        title: 'Gym memberships',
        description:
          'Cover gym costs upfront, with employees repaying monthly through salary — and saving on NI.'
      },
      {
        title: 'Cycle to work',
        description:
          'Provide bikes and accessories with no upfront spend. Great for health, wellbeing and commuting.'
      },
      {
        title: 'Car maintenance',
        description:
          'Let staff cover MOTs, tyres or repairs through Halfords and pay monthly via salary deduction.'
      },
      {
        title: 'Mobile tech',
        description: 'Let staff spread the cost of the latest smartphones, sim free and unlocked.'
      },
      {
        title: 'Holiday trading',
        description: 'Staff can buy or sell extra holiday based on their lifestyle needs.'
      },
      {
        title: 'Health cash plans',
        description: 'Cover everyday health costs like dental, optical and physio.'
      },
      {
        title: 'Home technology',
        description: 'Tech and appliances from Currys with monthly salary payments.'
      },
      {
        title: 'Will writing',
        description: 'Peace of mind with expert legal support and lower cost.'
      },
      {
        title: 'Discounts & rewards',
        description: 'Save on shopping, travel, leisure and more.'
      }
    ],
    viewText: 'View',
    editText: 'Edit',
    applyShoorahBenefitsPlanTtext: 'Apply Shoorah Benefits Plan'
  }
};
